import { importConstants } from './import-localization';

const leftNavConstants = {
    APPLICATION_PRIORITIZATION: 'Application prioritization',
    APP_CONFIG_STALE_HEADER: 'Your existing prioritization is based on out-of-date application configuration',
    APP_CONFIG_STALE_P1: 'Please click \'Action\' and \'Start from the beginning\' to configure your prioritization using the latest application information.',
    ASSETS: 'Assets',
    AWS: 'AWS',
    BACK_TO_ALL_PORTFOLIOS: 'View All portfolios',
    CASH_FLOW: 'Cash flow',
    COLLECT: 'Collect',
    CONTACT_MANAGEMENT: 'Contact management',
    COST_SUMMARY: 'Summary',
    DASHBOARDS: 'Dashboards',
    DATABASE_COST: 'Database cost',
    DATA_COLLECTION: 'Data collection',
    DEPENDENCIES: 'Dependencies',
    DEPENDENCY_GROUPS: 'Dependency groups',
    EC2_COST: 'EC2 cost',
    EC2_RECOMMENDATIONS: 'EC2 recommendations',
    HEADER: 'Portfolio Assessment',
    IMPORT: 'Import',
    IMPORT_FROM_ADS: 'Import from ADS',
    IMPORT_FROM_FILE: 'Import from file',
    IT_LABOR_SUPPORT_COST: 'IT labor and support cost',
    MIGRATION_STRATEGY: 'Migration strategy',
    MIGRATION_STRATEGY_RECOMMENDATIONS: 'Recommendations',
    MIGRATION_WAVES: 'Migration waves',
    ON_PREMISES: 'On-Premises',
    ON_PREM_DATABASE_COST: 'Database cost',
    ON_PREM_IT_LABOR_COST: 'IT labor cost',
    ON_PREM_SERVER_COST: 'Server cost',
    ON_PREM_STORAGE_NETWORK_COST: 'Storage and network cost',
    PLAN: 'Plan',
    PORTFOLIOS: 'Portfolios',
    PORTFOLIO_DATA: 'Portfolio data',
    PROPERTIES: 'Properties',
    RDS_COST: 'RDS cost',
    RDS_RECOMMENDATIONS: 'RDS recommendations',
    RECOMMENDED_TOOL: 'Recommended Tool',
    SERVER_COST: 'Server cost',
    SQL_SERVER_OPTIMIZATION: 'SQL Server optimization',
    STORAGE_NETWORK_COST: 'Storage and network cost',
    TCO: 'TCO',
    TCO_SUMMARY: 'Summary',
    VIEW: 'View',
};

const breadcrumbConstants = {
    BREADCRUMB_ADD_ADJUSTMENT: 'New adjustment',
    BREADCRUMB_ADJUSTMENTS: 'Adjustments',
    BREADCRUMB_ALL_PORTFOLIOS: 'All portfolios',
    BREADCRUMB_APPLICATION_COST_SUMMARY: 'Application cost summary',
    BREADCRUMB_APPLICATION_PRIORITIZATION: 'Application prioritization',
    BREADCRUMB_AWS_EC2_COSTS: 'AWS EC2 costs',
    BREADCRUMB_AWS_EC2_RECOMMENDATIONS: 'AWS EC2 recommendations',
    BREADCRUMB_AWS_IT_SUPPORT_COSTS: 'AWS IT labor and support costs',
    BREADCRUMB_AWS_RDS_COSTS: 'AWS RDS costs',
    BREADCRUMB_AWS_RDS_RECOMMENDATIONS: 'AWS RDS recommendations',
    BREADCRUMB_AWS_STORAGE_NETWORK_COSTS: 'AWS storage and network costs',
    BREADCRUMB_CONTACT_MANAGEMENT: 'Contact management',
    BREADCRUMB_CURRENT_PORTFOLIO: 'Current portfolio',
    BREADCRUMB_DASHBOARDS: 'Dashboards',
    BREADCRUMB_DATA_COLLECTION: 'Data collection',
    BREADCRUMB_DEPENDENCY_GROUPS: 'Dependency groups',
    BREADCRUMB_EDIT_ADJUSTMENT: 'Edit adjustment',
    BREADCRUMB_FAQ: 'FAQ',
    BREADCRUMB_IMPORT_FILE: 'Import file',
    BREADCRUMB_IMPORT_FROM_ADS: 'Import from ADS',
    BREADCRUMB_MAINFRAME_SUMMARY: 'Mainframe summary',
    BREADCRUMB_MANAGE_ASSETS: 'Manage assets',
    BREADCRUMB_MANAGE_DEPENDENCIES: 'Manage dependencies',
    BREADCRUMB_MIGRATION_CASH_FLOW: 'Cash flow',
    BREADCRUMB_MIGRATION_COST: 'Migration cost',
    BREADCRUMB_MIGRATION_STRATEGY_RECOMMENDATION: 'Migration strategy recommendation',
    BREADCRUMB_MIGRATION_WAVES: 'Migration waves',
    BREADCRUMB_NEW_PORTFOLIO: 'New portfolio',
    BREADCRUMB_ON_PREM_DATABASE_COST: 'On-Premises database cost',
    BREADCRUMB_ON_PREM_IT_LABOR_COST: 'On-Premises IT labor cost',
    BREADCRUMB_ON_PREM_SERVER_COST: 'On-Premises server cost',
    BREADCRUMB_ON_PREM_STORAGE_NETWORK_COST: 'On-Premises storage and network cost',
    BREADCRUMB_PLAN: 'Plan',
    BREADCRUMB_PROPERTIES: 'Properties',
    BREADCRUMB_SQL_SERVER_OPTIMIZATION: 'SQL Server optimization',
    BREADCRUMB_TCO: 'TCO',
    MANAGE_ASSETS: 'Manage assets',
};

export const helpPanelConstants = {
    ADJUSTMENTS_ADD_HEADER: 'Add adjustments',
    ADJUSTMENTS_ADD_P1: 'On this page you can create an adjustment for either AWS, On-Premises, or both.',
    ADJUSTMENTS_ADD_EDIT_P1: 'Use a unique description so the adjustment can be identified among the others. The category is used to map against the '
        + 'corresponding breakdowns on the TCO > Summary > Cash flow view. You can specify the frequency with which the amounts apply. ',
    ADJUSTMENTS_ADD_EDIT_P2: 'Toggling an adjustment out of scope will exclude it from the TCO calculations. For AWS adjustments, '
        + 'keep the \'Considered for AWS Support\' enabled to have the amount considered in the basis of the AWS Support cost estimation.',
    ADJUSTMENTS_EDIT_HEADER: 'Edit adjustments',
    ADJUSTMENTS_EDIT_P1: 'On this page you can edit adjustments and add a corresponding adjustment, if one does not already exist.',
    ADJUSTMENTS_TCO_CALC_WARNING: 'Note that changes to adjustments are not automatically considered in the TCO, '
        + 'you need to click \'Calculate\' for that to happen.',
    ADJUSTMENTS_VIEW_P1: 'Use adjustments to add additional costs to either the AWS or On-Premises TCO. '
        + 'Just like assumptions, but unlike assets data, adjustments work per assessment.',
    ADJUSTMENTS_VIEW_P2: 'On this page, you can view, edit and delete all the adjustments in the assessment, as well as add new ones.',
    ADJUSTMENTS_VIEW_P3: 'You can keep track of correspondent on-premises vs AWS adjustments. Select any row in the table and it will show '
        + 'you the details of that adjustment and its corresponding one, if one exists.',
    ALL_PORTFOLIOS_P1: 'This page lists all the portfolios that you have either created or been granted access to.',
    ALL_PORTFOLIOS_P2: 'Everything in MPA happens in a portfolio, which you create and, initially, have sole access to. A portfolio is where the customer data'
        + ' is imported and where all the results are available. You can create as many portfolios as needed and switch freely between them: what you change'
        + ' in one portfolio is not impacting the others.',
    ALL_PORTFOLIOS_P3: 'Click the portfolio name link to navigate to that particular portfolio.',
    APPLICATION_COST_DETAILS: 'Application cost details',
    APPLICATION_COST_DETAILS_P1: 'This page presents the estimated cost of the application. MPA estimates the cost of an application by computing'
        + ' the direct cost of its resources (servers and databases), and distributing common costs across all applications.'
        + ' For this reason, an application\'s cost is updated every time \'Calculate\' is clicked in the TCO pages.',
    APPLICATION_COST_DETAILS_P2: 'For more details, please see the ',
    APPLICATION_COST_SUMMARY_P1: 'This page presents the estimated costs of all in scope applications. MPA estimates the cost of an application by computing'
        + ' the direct cost of its resources (servers and databases), and distributing common costs across all applications.'
        + ' For this reason, an application\'s cost is updated every time \'Calculate\' is clicked in the TCO pages.',
    APPLICATION_COST_SUMMARY_P2: 'To see the total cost of just some of the applications, select them and press \'Update summary totals\'.',
    APPLICATION_COST_SUMMARY_P3: 'For more details, please see the ',
    APPLICATION_GRPOUPS_P1: 'Dependency grouping, also referred to as application grouping, enables you to account for dependencies within the wave plan.'
        + ' This requires diligent review of dependencies between applications and their assets.',
    APPLICATION_GRPOUPS_P2: 'It is common to have several large groups and many more very small (often single application) groups. Small groups are generally'
        + ' ready to assign to a wave. Larger groups should be reviewed and decided if they can be split up into smaller groups by having a preference for one'
        + ' side of a dependency (i.e., if there is a shared database, picking which applications will migrate with the database and which will not).',
    APPLICATION_GRPOUPS_P3: 'Use the options in the \'Actions\' menu to manage the content of groups through marking resources as shared infrastructure,'
        + ' removing applications and/or dependencies by type.',
    APPLICATION_OVERVIEW: 'Application overview',
    APPLICATION_OVERVIEW_P1: 'This page displays the attributes of the application and assigned customer contact.',
    APPLICATION_PRIORITIZATION_P1: 'The application prioritization enables you to align to your customers business and technical drivers for migration.',
    APPLICATION_PRIORITIZATION_P2: 'Step 1: select one or more attributes relevant to your customer’s drivers. Then score individual values imported for'
        + ' the selected attribute. For numerical fields you will need to establish ranges of values and score the range. Higher scores equate to higher'
        + ' priority/rank for migration.',
    APPLICATION_PRIORITIZATION_P3: 'Step 2: drag each selected attribute from the “unranked” column to the column most representative of how strongly the'
        + ' attribute aligns to the customers drive to migrate.',
    APPLICATION_PRIORITIZATION_P4: 'Once the 2-step process is completed the applications will be prioritized. Review the histogram chart at the top to'
        + ' ensure applications are distributed across the spectrum of low to high priority. Less distribution in this diagram means there is little'
        + ' difference between low and high priority and the goal of this exercise is to create differentiation. Lastly, present the application'
        + ' prioritization table at the bottom of the page to your customer to see if they agree with the prioritization.',
    APPLICATION_RESOURCES: 'Application resources',
    APPLICATION_RESOURCES_P1: 'This page displays the servers and databases associated with the selected application.',
    APPLICATION_RESOURCES_P2: 'To view detailed on-premises and in AWS information, select a server or database from the table.',
    ASSETS_APPLICATIONS: 'Applications',
    ASSETS_DATABASES: 'Databases',
    ASSETS_HEADER: 'Managing asset data',
    ASSETS_NETWORK: 'Network',
    ASSETS_P1: 'This page is to help you manage data regarding customer assets and is broken into 5 main sections:',
    ASSETS_P2: 'Servers, as well as Shared storage and Network assets, are primarily used for cost calculations.'
        + ' Applications and Databases are currently used only for migration planning.',
    ASSETS_P3: 'In each section, you will see checks for the validity of the data. MPA has default rules which checks the data for common data'
        +  ' issues, and creates quick links to filter and see the specific data which appears to be invalid. Rules can be removed, added, or edited'
        + ' as part of your portfolio to assist in increasing the data quality for your customer. In this portion of the page, you can also download'
        + ' a report of the invalid data to share with your customer.',
    ASSETS_P4: 'For details on the most relevant attributes, see the ',
    ASSETS_SERVERS: 'Servers',
    ASSETS_SHARED_STORAGE: 'Shared storage',
    AWS_IT_AND_SUPPORT_HELP_P1: 'This page presents the estimated labor and support costs associated with operating the in-scope workloads on AWS.'
        + ' IT labor costs are calculated using administrator\'s salary (in \'Assumptions > AWS IT labor and support\'), and the number of'
        + ' EC2 and RDS instances, and the size of the server and database storage.',
    AWS_IT_AND_SUPPORT_HELP_P2: 'Support costs are calculated using the AWS Support plan option (also in \'Assumptions > AWS IT labor and support\')'
        + ' and the anticipated monthly charges.',
    AWS_PRICING_CALCULATOR: 'AWS Pricing Calculator',
    AWS_STORAGE_AND_NETWORK_HELP_P1: 'This page presents the estimated AWS cost for your storage and network assets. Storage costs include the costs for the'
        + ' storage of physical and virtual servers, shared storage, and database storage. Each table at the bottom of the page shows cost details and'
        + ' the associated annual cash flow broken down by the AWS service, as well as the costs corresponding to each server/database.',
    AWS_STORAGE_AND_NETWORK_HELP_P2: 'Configure specific storage parameters in \'Assumptions > AWS storage\' for server level storage and in \'Assumptions >'
        + ' General storage\' for shared storage. For network settings, see \'Assumptions > AWS network\'.',
    CONTACT_MANAGEMENT_P1: 'Data collection in MPA works at asset level: you choose for which asset you need more info, assign that to a customer contact,'
        + ' configure the questionnaire you want to send to the contact and then send that questionnaire.',
    CONTACT_MANAGEMENT_P2: 'Contact information loaded as part of the asset import process will appear on this page. To create a new contact,'
        + ' click \'Add contact\'. Next, assign the contact ownership of an application, server, or database. Finally, start a data request by'
        + ' clicking the \'Start data request\' button at the top of the screen, or navigate to the \'Data collection\' page.',
    CREATE_PORTFOLIO_P1: 'A portfolio is defined by its name and the customer account it belongs to. Give your new portfolio a meaningful name and specify the'
        + ' account to use.',
    CREATE_PORTFOLIO_P2: 'In the \'Portfolio data\' you can select \'Sample data\' to generate a portfolio pre-loaded with default assets - a good option to'
        + ' get yourself familiarized with MPA. If you have actual customer data, select \'No data\'; if you intend to use the MPA results for review with the'
        + ' customer, indicate the data classification as \'Customer data\'.',
    CREATE_PORTFOLIO_P3: 'You can also add one or more tags to help you categorize the portfolios you own with pre-defined or custom keys. These can be'
        + ' changed later on the \'Edit properties\' page.',
    CREATE_RULE: 'Create rule',
    CREATE_RULE_P1: 'To create a rule, enter the name of the rule and a description. This information will appear on the assets page.',
    CREATE_RULE_P2: 'Select one or more impact areas and assign each one a severity level. This is based on their relative impact on each assessment.',
    CREATE_RULE_P3: 'The last step is to define the criteria which must evaluate to true for the asset data to pass the rule. You can use the groups'
        + ' (AND/OR) to create complex rules that check for multiple sets of values or ensure that values are valid in the context of another data field.',
    CREATE_RULE_P4: 'You may create multiple rules for a single attribute.',
    CREATE_RULE_P5: 'You must validate the rule clause before you will be able to save the rule.',
    DASHBOARDS_P1: 'Use this page to visualize the data in your portfolio.',
    DASHBOARDS_P2: 'For now, only server data is supported, both input and EC2 recommendations attributes.',
    DATA_COLLECTION_P1: 'Data collection in MPA works at asset level: you choose for which asset you need more info, assign that to a customer contact,'
        + ' configure the questionnaire you want to send to the contact and then send that questionnaire.',
    DATA_COLLECTION_P2: 'You can manage contacts info and their assignments on the \'Contact management\' page.',
    DATA_COLLECTION_P3: 'For questionnaires, MPA has a default template for each asset type which you can further customize by clicking \'Edit questionnaire'
        + ' template\'. You can also choose to customize the questionnaire for each asset individually by clicking the asset id link. By default, the asset'
        + ' level questionnaire is the template for that asset type.',
    DATA_COLLECTION_P4: 'To send a questionnaire, set a due date and click the \'Send selected request(s)\' button, then either send the customer users an'
        + ' email, or click the “Send” button to automatically have one drafted for you to send via your email client.',
    DEFAULT_P1: 'Portfolio assessment is the discovery, identification, classification and grouping of On-Premises compute'
        + ' infrastructure by application in order to determine the feasibility, effort, cost, tools and resources, all'
        + ' leading to a Migration Effort Analysis and Migration Priority Pipeline that can guide the customer in'
        + ' planning their migration to Amazon Web Services.',
    DEFAULT_P2: 'MPA consolidates the portfolio data in one place, helps in migration planning and provides the information'
        + ' required for validating the migration business case: EC2 recommendations, On-Premises cost estimation and equivalent'
        + ' AWS cost estimation, migration strategy and migration project cost.',
    DEPENDENCIES_HEADER: 'Managing dependency data',
    DEPENDENCIES_L1: 'Server to application - The mapping of servers to the applications they support',
    DEPENDENCIES_L2: 'Server communication - The mapping of IP/Port communications between servers',
    DEPENDENCIES_L3: 'Database to application - The mapping of databases to the applications they support',
    DEPENDENCIES_L4: 'Application dependency - The direct mapping of application dependencies',
    DEPENDENCIES_P1: 'This page is to help you manage data regarding dependencies between customer assets and is broken into four main sections: ',
    DEPENDENCIES_P2: 'All four of these dependency types are used for application grouping. These are not currently used elsewhere in the tool.',
    DEPENDENCIES_P3: 'In each section, you will see checks for the validity of the data. MPA will check if the assets exist in the appropriate asset table.'
        + ' For example, if App1 depends on Server1 in the Server to application table: App1 must match to an ID in the application asset table'
        + ' and Server1 must match to an ID in the Server asset table.',
    DEPENDENCIES_P4: 'For more in-depth guidance, please see the links below.',
    IMPORT_FROM_ADS_P1: 'To import data from the AWS Application Discovery Service, you will need to first provision an IAM role with the'
        + ' discovery:DescribeConfigurations and discovery:ListConfigurations permissions.',
    IMPORT_FROM_ADS_P2: 'Once the role has been provisioned you will need the access key information to copy into the needed fields.'
        + ' You should also verify that the region selected is where the ADS data is stored.',
    IMPORT_FROM_FILE_P1: 'To import data from a file, first select the type of data (ex: servers, applications) you will be importing on the left-hand'
        + ' side of the screen. Then select the file to upload.',
    IMPORT_FROM_FILE_P2: 'You will then be walked through a wizard process for mapping headers (i.e., telling MPA about the data you want to store from the'
        + ' file) and additional steps if you have already loaded some data into MPA or your file contains duplicative data. The additional steps will help'
        + ' you merge and deduplicate data to assist with creating a single source of truth within MPA.',
    EC2_COST_HELP_P1: 'This page presents the cost summary and details for the recommended EC2 instances: EC2 cash flow, EC2 cost per instance'
        + ' type, pricing details per input server and payment option, Dedicated Host breakdown, and 3rd party license cost estimates.',
    EC2_COST_HELP_P2: 'VMC pricing details are also shown here if VMware Cloud on AWS is enabled in \'Assumptions > General\'.',
    EC2_RECOMMENDATIONS_HELP: 'The \'EC2 recommendations\' page shows recommended EC2 instances and host types for your On-Premises servers. The'
        + ' recommendations are based on CPU, memory and utilization data imported or assumed; see \'Assumptions > EC2 server recommendations\' for default'
        + ' utilization settings. The recommended payment option is based on the server usage % (when missing, the server usage is inferred from'
        + ' \'Assumptions > EC2 server cost\' based on the environment type.',
    EC2_RECOMMENDATIONS_HELP_DH: 'Dedicated Hosts',
    EC2_RECOMMENDATIONS_HELP_EXCLUSIONS: 'Specifying exclusions',
    EC2_RECOMMENDATIONS_HELP_GRAVITON: 'Recommending Graviton',
    EC2_RECOMMENDATIONS_HELP_HOW: 'EC2 recommendations',
    EC2_RECOMMENDATIONS_HELP_OVERRIDE: 'Overriding recommendations',
    EC2_RECOMMENDATIONS_HELP_PREFERENCES: 'Specifying preferences',
    EC2_RECOMMENDATIONS_HELP_ORACLE_BYOL: 'EC2 shared with Oracle BYOL',
    EC2_RECOMMENDATIONS_HELP_SQLSERVER_LI: 'EC2 with SQL Server license included',
    EC2_RECOMMENDATIONS_HELP_TROUBLESHOOTING: 'Troubleshooting',
    EDIT_RULE: 'Edit rule',
    EDIT_RULE_P1: 'All custom rules can be edited. Default rules cannot be changed but they can be disabled on the assets page.',
    EDIT_RULE_P2: 'You may create multiple different rules for an attribute or edit the clause to be more complex depending on what you wish to validate.',
    EDIT_RULE_P3: 'You must validate the rule clause before you will be able to save the rule.',
    FAQ: 'FAQ',
    HANDS_ON_GUIDE: 'MPA hands-on guide',
    IMPACT_BADGE_HIGH: ' These issues are likely to cause major differences in recommendations and should be reviewed diligently.',
    IMPACT_BADGE_LOW: ' These issues may cause differences in some scenarios but otherwise are not concerning and should be reviewed as time permits.',
    IMPACT_BADGE_MEDIUM: ' These issues are likely to cause differences in recommendations in some scenarios and should be reviewed.',
    LEARN_MORE: 'Learn more',
    MAINFRAME_SUMMARY_P1: 'This page presents all the results of the Mainframe assessment based on the data you have provided in \'Assets > Mainframe\'.',
    MAINFRAME_SUMMARY_P2: 'The \'Summary\' tab has the estimated annual On-premises and AWS costs, as well as a rough order of magnitude estimation'
        + ' of the migration costs.',
    MAINFRAME_SUMMARY_P3: 'The \'Cash flow\' tab shows a comparison between the On-premises no change scenario and a gradual migration to AWS.',
    MAINFRAME_SUMMARY_P4: 'The \'AWS details\' tab breaks down the annual AWS cost.',
    MIGRATION_CASH_FLOW: 'Migration cash flow',
    MIGRATION_CASH_FLOW_P1: 'Migration cash flow is determined by breaking down the overall migration cost into quarters.'
        + ' In each quarter, a percent of the overall effort will be spent and this is configured in the Migration completion plan.',
    MIGRATION_CASH_FLOW_P2: 'The cash flow is compared to the on-premises cost over each quarter to show the bubble cost and eventual ROI of migration.',
    MIGRATION_CASH_FLOW_P3: 'The cost detail section shows the annual cash flow to compare migration with remaining on-premises.',
    MIGRATION_COST_SUMMARY: 'Migration cost summary',
    MIGRATION_COST_SUMMARY_P1: 'The migration cost is estimated based on the level of effort to migrate and the cost of the resources who will conduct'
        + ' the migration. Additional costs for tooling and training are also included. Level of effort is determined by the migration strategies.',
    MIGRATION_COST_SUMMARY_P2: 'Sprint teams can be configured in the \'Server sprint team resources\' and \'Database sprint team resources\'.'
        + ' Sprint teams align to migration strategies and roles. Each role can be assigned an hourly rate; default values are provided based on the'
        + ' migration project\'s location.',
    MIGRATION_STRATEGY_HELP: 'Migration strategy recommendations',
    MIGRATION_STRATEGY_HELP_P1: 'Migration strategies for servers are primarily recommended based on the OS name and version attributes at server level.',
    MIGRATION_STRATEGY_HELP_P2: 'Recommended strategies can be overridden by selecting the servers to override and updating preferred the strategy.' 
        + ' Migration strategies are primarily used to calculate migration cost and can be manually input if no server data has been loaded by expanding'
        + ' the \'Migration strategy counts\' section.',
    MIGRATION_STRATEGY_HELP_P3: 'You can also set the preferred value in the \'Server-Migration Pattern\' attribute at server level.',
    MIGRATION_STRATEGY_HELP_P4: 'These strategies are rolled up to the application level based on the servers mapped to the application.',
    ONPREM_DATABASE_COST: 'On-Premises database cost',
    ONPREM_DATABASE_COST_P1: 'This page presents the estimated TCO of hosting databases in a customer owned or co-located datacenter.',
    ONPREM_DATABASE_COST_P2: 'For databases hosted on virtual servers, VMs are converted to physical hosts using the configured host types under the'
        + ' \'Host Servers\' tab.',
    ONPREM_DATABASE_COST_P3: 'The TCO includes the deployment costs, power, and facility corresponding to the servers, and database license costs.'
        + ' The cash flow view shows each of these costs annual expenditure for the TCO duration.',
    ONPREM_IT_LABOR: 'On-Premises IT and support cost',
    ONPREM_IT_LABOR_P1: 'This page presents the estimated IT and support costs of hosting workloads in a customer owned or co-located datacenter.',
    ONPREM_IT_LABOR_P2: 'IT labor costs are calculated using administrators salary, the number of servers and databases in-scope, and the size of the.'
        + ' raw server and database storage; the network admin cost is assessed as a percentage of the network cost.',
    ONPREM_SERVER_COST: 'On-Premises server cost',
    ONPREM_SERVER_COST_P1: 'This page presents the estimated TCO of hosting servers in a customer owned or co-located datacenter.',
    ONPREM_SERVER_COST_P2: 'Virtual servers are converted to physical hosts using the configured host types under the \'Host Servers\' tab.',
    ONPREM_SERVER_COST_P3: 'The TCO includes deployment costs, power, facility, and software license costs. The cash flow view shows each of these costs'
        + ' annual expenditure for the TCO duration.',
    ONPREM_STORAGE_AND_NETWORK: 'On-Premises storage and network cost',
    ONPREM_STORAGE_AND_NETWORK_P1: 'This page presents the estimated TCO of storage and network in a customer owned or co-located datacenter.',
    ONPREM_STORAGE_AND_NETWORK_P2: 'Costs for physical (local/fixed), SAN, NAS, and object storage are calculated based on the on-premises/co-located'
        + ' provisioned capacity and account for storage penalties and rack and software costs. Additionally, tape backup costs are calculated automatically.',
    ONPREM_STORAGE_AND_NETWORK_P3: 'Network costs include hardware and software costs, as well as bandwidth and maintenance costs.',
    PORTFOLIO_ASSESSMENT: 'Portfolio Assessment',
    PROPERTIES_P1: 'Use this page to set portfolio level attributes.',
    PROPERTIES_P2: 'For now, the portfolio name, the test indicator and the tags are supported. Use predefined tags or create your own.',
    PRESCRIPTIVE_GUIDANCE: 'Prescriptive Guidance',
    RECOMMENDATIONS_PRIORITY_ORDER: 'TCO recommendations priority order',
    RDS_COST_HELP_P1: 'This page presents the cost summary and details for the recommended RDS instances: RDS cash flow, cost details for each'
        + ' database per payment option, and 3rd party licensing information.',
    RDS_COST_HELP_P2: 'To see results on this page, toggle on \'Enable RDS recommendations\' in \'Assumptions > AWS database recommendations\'.'
        + ' For license details, enable \'Include database license assessment in TCO\' in \'Assumptions > Database licenses\'.',
    RDS_RECOMMENDATIONS_HELP_P1: 'The \'RDS recommendations\' page shows recommended RDS instance types for each database.'
        + ' The recommendations include right-sizing based on CPU, memory and utilization of the corresponding server, and.'
        + ' target DB engine, edition, license model and deployment option of the database; all values are used as provided in the imported data, or'
        + ' based on assumptions.',
    RDS_RECOMMENDATIONS_HELP_P2: 'Individual instance recommendations can be overridden by selecting one or more databases and'
        + ' specifying the recommendation type and instance type to update.',
    RDS_RECOMMENDATIONS_HELP_P3: 'Note that not all instance types are available in all regions and not all target DB engine, edition, license model and'
        + ' deployment option combinations are supported by RDS.',
    SEE_ALSO: 'See also:',
    SEVERITY_TERMS: 'Severity terms',
    SQL_SERVER_OPTIMIZATION_P1: 'Use this page to review potential savings for the SQL Server databases in your portfolio.',
    SQL_SERVER_OPTIMIZATION_P2: 'MPA applies server utilization to determine the optimized number of vCPUs, and also consolidates instances with less than'
        + ' 2 vCPUs. Additional references are presented for your consideration of SQL Edition optimization.',
    SQL_SERVER_OPTIMIZATION_P3: 'Note that none of the data presented here is included in the TCO summary, this is a separate analysis.',
    TCO_SUMMARY: 'TCO summary',
    TCO_SUMMARY_P1: 'The total cost of ownership summary page shows the overall calculated On-Premises cost and compares to the overall calculated AWS cost.'
        + ' The summary includes server (EC2), database (RDS), storage (EBS/S3/EFS), network, IT labor, and support costs.',
    TCO_SUMMARY_P2: 'Costs are calculated based on the data imported and assumptions. For more details on individual cost calculations, review the relevant'
        + ' AWS or On-Premises page and the associated assumptions.',
    TCO_SUMMARY_P3: 'This page also shows a year-by-year breakdown by cost category and a residual value for assets which still have value at the end of the'
        + ' refreshment period (often this is due to Reserved Instance Purchases).',
    TCO_SUMMARY_P4: 'This page does not include Migration Cost (project cost).',
    VALIDATION_RULES: 'Data validation rules',
    VALIDATION_RULES_P1: 'This tool uses pre-defined and user-defined rules to check for issues with the dataset. Each rule has associated'
        + ' impact areas to specify where the tool is making recommendations. These should be reviewed based on what you are'
        + ' trying to accomplish. Rules can be prioritized based on how impactful they are to the recommendations as'
        + ' well as how many times the issue occurs in the dataset.',
    VALIDATION_RULES_P2: 'To review, click the filter icon on the right-hand side of the table row. This will filter the asset table to only'
        + ' show assets which are identified as having issues defined by the associated rule.',
    VALIDATION_RULES_P3: 'To create a new rule, or disable/delete a rule, click the \'Actions\' from the dropdown menu.'
        + ' Pre-defined rules cannot be deleted, only disabled.',
    VALIDATION_RULES_P4: 'To edit an existing rule, click the edit icon on the right-hand side of the table row.',
    WAVE_PLANNING_P1: 'Wave planning allows you to assign migration groups to a timeline.',
    WAVE_PLANNING_P2: 'To begin, create at least one wave. Start by either creating a single wave or multiple waves at a time. If creating a single wave,'
        + ' directly set the start and end dates and the wave’s capacity. If creating multiple waves, set the first wave’s start date and the last wave’s'
        + ' (overall migration project) end date and the capacity (velocity) for each wave. After the waves are created it is possible to delete waves as'
        + ' well as edit the dates and capacity of individual waves in the lower section of the page.',
    WAVE_PLANNING_P3: 'Next, assign groups to waves. This can be done one group at a time by dragging and dropping the group in the timeline section.'
        + ' This can also be done in bulk by selecting the \'Groups\' tab in the table section, then selecting the groups you want to assign, then selecting'
        + ' \'Add to wave\'.',
    WHATS_NEW: 'What\'s new?',
};

const recentPortfolioConstants = {
    NO_RECENT_PORTFOLIOS: 'No recent portfolios',
    RECENT_PORTFOLIOS: 'Recent portfolios',
    RECENT_PORTFOLIOS_COOKIE_NOT_SET_MSG: 'This feature is not available,'
        + ' please visit the \'Cookie preferences\' in the footer and allow functional cookies to enable it.',
    VIEW_ALL_PORTFOLIOS: 'View all portfolios',
};

const shortbreadConstants = {
    ALLOW_FUNCTIONAL_COOKIES_TO_ENABLE: 'and allow functional cookies to enable this feature.',
    COOKIE_PREFERENCES: 'Cookie preferences',
    FEATURE_NOT_AVAILABLE: 'Feature not available',
    VISIT: 'Visit',
};

const dashboardConstants = {
    A_NAME_FOR_NEW_DASHBOARD: 'A name for the new dashboard',
    ARRANGE: 'Arrange',
    AVG_CPU_UTIL: 'Avg CPU utilization',
    AWS_INSTANCE_TYPE: 'AWS instance type',
    CANNOT_RENDER_CHART: 'Cannot render chart',
    CATEGORY: 'Category',
    CHART_LABEL: 'Chart label ...',
    CHART_LOWERCASE: 'chart',
    CHARTS_LOWERCASE: 'charts',
    CHART_DESCRIPTION: 'A short description for this chart',
    CHART_TYPE: 'Chart type',
    CHOOSE_A_PROPERTY: 'Choose a property',
    CLICK_ADD_CHART_TO_START: 'Click the \'Add\' button to get started.',
    CLONE: 'Clone',
    COMPUTE_CAPACITY_COUNT: 'Compute capacity (count)',
    COMPUTE_CAPACITY_COUNT_DESC: 'Count of servers by number of CPUs configured',
    COMPUTE_UTILIZATION_COUNT: 'Compute utilization (count)',
    COMPUTE_UTILIZATION_COUNT_DESC: 'Count of servers by average CPU utilization, partitioned into ranges',
    CREATE_DASHBOARD: 'Create dashboard',
    DASHBOARD_NAME: 'Dashboard name',
    DEFAULT_LOWERCASE: 'default',
    FUNCTION: 'Function',
    HIDE_LABELS: 'Hide labels',
    INSTANCE_COST: 'Instance cost',
    INSTANCE_TYPE_MAPPING: 'Instance type mapping',
    INSTANCE_TYPE_MAPPING_DESC: 'Count of EC2 instance type',
    INSUFFICIENT_DATA_WARNING: 'Insufficient data available or data out of range.',
    MEMORY_CAPACITY_COUNT: 'Memory capacity (count)',
    MEMORY_CAPACITY_COUNT_DESC: 'Count of servers by total RAM, partitioned into ranges',
    NUMBER_OF_INSTANCES: 'Number of instances',
    OPERATING_SYSTEM_COUNT: 'Operating system (count)',
    OPERATING_SYSTEM_COUNT_DESC: 'Count of servers by operating system',
    OPTIONAL: 'optional',
    PARTITION_DESCRIPTION: 'Use partitions to show in your charts value ranges for the selected category.',
    PARTITION_VALUES: 'Partition values',
    RAM: 'RAM',
    REMOVE_ALL: 'Remove ALL',
    REMOVE_ALL_CHARTS_MSG: 'All charts in this dashboard will be removed. This action cannot be undone.',
    REMOVE_DASHBOARD: 'Remove dashboard',
    REMOVE_DASHBOARD_WARNING: 'The dashboard and all of its charts will be removed. This action cannot be undone.',
    RESTORE_DEFAULT_CHARTS: 'Restore default charts?',
    RESTORE_DEFAULTS: 'Restore defaults',
    RESTORE_DEFAULTS_MSG: 'All charts in this dashboard will be replaced by the default set of charts. This action cannot be undone.',
    SERVER_STORAGE: 'Storage',
    SERVER_TYPE_COUNT: 'Server type (count)',
    SERVER_TYPE_COUNT_DESC: 'Count of servers by type: host or VM',
    SERVER_UPTIME_COUNT: 'Server uptime (count)',
    SERVER_UPTIME_COUNT_DESC: 'Count of servers by uptime, partitioned into ranges',
    SHOW_LABELS: 'Show labels',
    STORAGE_CAPACITY_COUNT: 'Storage capacity (count)',
    STORAGE_CAPACITY_COUNT_DESC: 'Count of servers by total storage, partitioned into ranges',
    TOTAL_COST_PER_INSTANCE: 'Total cost per instance',
    UNABLE_TO_REMOVE_CHART: 'Unable to remove selected chart',
    UNAVAILABLE: 'Unavailable',
    UPTIME: 'Uptime',
    YOU_HAVE_YET_TO_ADD_A_CHART: 'You have yet to add a chart.',
};

const portfoliosTableConstants = {
    DATE_TYPES_THAT_WILL_BE_COPIED: 'Servers, server to application mappings, applications, contacts, databases, database to application mappings,' + 
        ' network data, storage data, and server to server communication data.',
    DELETE_PORTFOLIOS: 'Delete portfolios',
    ERROR_LOADING_PORTFOLIOS: 'Failed to load portfolios',
    ERROR_LOADING_PORTFOLIO: 'Failed to load portfolio',
    FAIL_TO_COPY_PORTFOLIO: 'Failed to copy portfolio',
    FAIL_TO_DELETE_PORTFOLIO: 'Failed to delete portfolios',
    FAIL_TO_UPDATE_PORTFOLIO: 'Failed to update portfolio',
    FOLLOWING_WILL_BE_COPIED: 'The following data will be copied:',
    NEW_PORTFOLIO_NAME: 'New portfolio name*:',
    OVERSIZED_HEADER: 'Oversized portfolio',
    OVERSIZED_PORTFOLIO: 'You have {0} {1} in this portfolio, which exceeds the recommend threshold: {2}.'
    + ' You might experience limited support in Data Quality/Migration Wave features and slowness in TCO feature.'
    + ' Please consider breaking your resources into multiple smaller portfolios for better user experience.',
    PORTFOLIOS_ACCOUNT_NAME: 'Account name',
    PORTFOLIOS_CREATED_AT: 'Created',
    PORTFOLIOS_NAME: 'Portfolio name',
    PORTFOLIOS_TABLE_HEADER: 'Portfolios',
    PORTFOLIOS_UPDATED_AT: 'Updated',
    PORTFOLIOS_UPDATED_BY: 'Last updated by',
    TAGS: 'Tags',
    TAG_VALUES: 'Tag values',
    TEST_PORTFOLIO: 'Test portfolio*:',
    TEST_PORTFOLIO_DESCRIPTION: 'Data imported into this portfolio is for testing/demo purposes and is not customer data.',
    YOU_ARE_ABOUT_TO_DELETE: 'You are about to delete ',
};

const sharedStorageConstants = {
    DISK_TYPE: 'Disk type',
    EBS_VOLUME_TYPE: 'EBS volume type',
    SHARED_STORAGE_ITEM: 'shared storage item',
    STORAGE: 'shared storage',
    STORAGE_ACCESSED_INFREQUENTLY_PCT: 'Accessed infrequently (%)',
    STORAGE_ADD_BUTTON_TEXT: 'Add shared storage',
    STORAGE_ADD_MODAL_HEADER: 'Add shared storage',
    STORAGE_CAPACITY: 'Raw/Usable',
    STORAGE_DELETE_MODAL_HEADER: 'Delete shared storage',
    STORAGE_DESCRIPTION: 'Description',
    STORAGE_EDIT_MODAL_HEADER: 'Edit shared storage',
    STORAGE_ERROR_LOADING: 'Failed to load shared storage',
    STORAGE_EXCLUDE_FROM_TCO: 'Exclude from TCO',
    STORAGE_MAX_IOPS: 'Max IOPS',
    STORAGE_OBJECT_SERVICE: 'Object service',
    STORAGE_SIZE_IN_GB: 'Size (GB)',
    STORAGE_SYSTEM: 'Block service',
    STORAGE_TABLE_HEADER: 'Shared storage',
    STORAGE_TYPE: 'Storage type',
};

const applicationsTableConstants = {
    ADD_ATTRIBUTE_FAILED: 'Failed to add schema.',
    ADD_ATTRIBUTE_SUCCESS: 'Successfully added schema.',
    APPLICATION_EDITING_ERROR_HEADING: 'Failed to update application',
    APPLICATION_ERROR_LOADING: 'Failed to load application',
    APPLICATION_RESOURCE_NAME: 'Application',
    APPLICATION_TABLE_HEADER: 'Applications',
};

const serverTableConstants = {
    APPLICATION_MAPPED_COLUMN_HEADER: 'Application Mapped',
    DATABASE_MAPPED_COLUMN_HEADER: 'Database Mapped',
    RESOURCE_MAPPED: 'Mapped',
    RESOURCE_UNMAPPED: 'Unmapped',
    SERVER_DELETE_ERROR_HEADING: 'Failed to delete servers',
    SERVER_EDITING_ERROR_HEADING: 'Failed to update servers',
    SERVER_ERROR_LOADING: 'Failed to load servers',
    SERVER_ERROR_DOWNLOAD: 'Failed to download servers',
    SERVER_MAPPED_COLUMN_HEADER: 'Server Mapped',
    SERVER_RESOURCE_NAME: 'Server',
    SERVER_TABLE_HEADER: 'Servers',
};

const databaseTableConstants = {
    DATABASE_DELETE_ERROR_HEADING: 'Failed to delete databases',
    DATABASE_EDITING_ERROR_HEADING: 'Failed to update databases',
    DATABASE_ERROR_LOADING: 'Failed to load databases',
    DATABASE_RESOURCE_NAME: 'Database',
    DATABASE_TABLE_HEADER: 'Databases',
};

const appToServerTableConstants = {
    APP_SERVER_DELETE_ERROR_HEADING: 'Failed to delete application to server mappings',
    APP_SERVER_EDITING_ERROR_HEADING: 'Failed to update application to server mappings',
    APP_SERVER_ERROR_LOADING: 'Failed to load application to server mappings',
    APP_SERVER_RESOURCE_NAME: 'Server to application',
    APP_SERVER_TABLE_HEADER: 'Server to application mappings',
};

const serverCommTableConstants = {
    SERVER_COMM_DELETE_ERROR_HEADING: 'Failed to delete server communications',
    SERVER_COMM_EDITING_ERROR_HEADING: 'Failed to update server communications',
    SERVER_COMM_ERROR_LOADING: 'Failed to load server communications',
    SERVER_COMM_RESOURCE_NAME: 'Server communications',
    SERVER_COMM_TABLE_HEADER: 'Server communications',
};

const dbToAppTableConstants = {
    DB_APP_DELETE_ERROR_HEADING: 'Failed to delete database to application mappings',
    DB_APP_EDITING_ERROR_HEADING: 'Failed to update database to application mappings',
    DB_APP_ERROR_LOADING: 'Failed to load database to application mappings',
    DB_APP_RESOURCE_NAME: 'Database to application',
    DB_APP_TABLE_HEADER: 'Database to application mappings',
};

const appDependenciesTableConstants = {
    APP_DEP_DELETE_ERROR_HEADING: 'Failed to delete application dependencies',
    APP_DEP_EDITING_ERROR_HEADING: 'Failed to update application dependencies',
    APP_DEP_ERROR_LOADING: 'Failed to load application dependencies',
    APP_DEP_RESOURCE_NAME: 'Application dependencies',
    APP_DEP_TABLE_HEADER: 'Application dependencies',
};

const dependencyValidation = {
    ALL_DEPENDENCY_PASSED_VALIDATION: 'All dependencies passed the validation checks',
    APPLICATION_MAPPED: 'Application Mapped',
    DATABASE_MAPPED: 'Database Mapped',
    SERVER_MAPPED: 'Server Mapped',
    THIS_FIELD_CANNOT_BE_UPDATED: 'This field cannot be updated',
    USE_FOLLOWING_FILTERS_TO_CORRECT_INVALID_VALUES: 'Please use the following filters to help correct invalid values:',
    VALIDATION_ERRORS_IN_DEPENDENCY_DATA: ' validation errors in your dependency data',
};

const networkConstants = {
    NETWORK: 'network',
    NETWORK_UPPERCASE: 'Network',
    NETWORK_ADD_BUTTON_TEXT: 'Add network',
    NETWORK_ADD_MODAL_HEADER: 'Add network',
    NETWORK_DELETE_MODAL_HEADER: 'Delete network',
    NETWORK_EDIT_MODAL_HEADER: 'Edit network',
    NETWORK_ERROR_LOADING: 'Failed to load network',
    NETWORK_EXCLUDE_FROM_TCO: 'Exclude from TCO',
    NETWORK_INTERNET_EGRESS: 'AWS egress data transfer (GB/Month)',
    NETWORK_RATIO: 'Peak/Average ratio',
    NETWORK_REDUNDANT_PIPE: 'Redundant pipe (Yes/No)',
    NETWORK_SIZE_OF_PIPE: 'Size of pipe (Mbits/second)',
    NETWORK_TABLE_HEADER: 'Network (current bandwidth)',
};

const previewBannerConstants = {
    PREVIEW_THIS_IS_A_PREVIEW_FEATURE: 'This is a preview feature',
};

const formConstants = {
    FORM_DECIMAL_PLACES: 'decimal place(s)',
    FORM_DELETE_ERROR_CONTENT: 'You are about to delete the following ',
    FORM_DELETE_ERROR_PROCEED: 'Do you want to proceed?',
    FORM_DELETE_ERROR_TITLE: 'This action cannot be undone',
    FORM_PRIMARY_BUTTON_ADD: 'Add',
    FORM_PRIMARY_BUTTON_COMPARE: 'Compare',
    FORM_PRIMARY_BUTTON_DELETE: 'Delete',
    FORM_PRIMARY_BUTTON_SAVE: 'Save',
    FORM_SHOULD_BE_NO_GREATER_THAN: 'Should be no greater than',
    FORM_SHOULD_BE_NO_LESS_THAN: 'Should be no less than',
    FORM_VALUE_MUST_BE_DEFINED: 'A value must be defined',
};

const commonConstants = {
    ACTION_BUTTON_TEXT: 'Actions',
    ADD_BUTTON_TEXT: 'Add',
    APPLICATIONS: 'Applications',
    APPLICATION_S: 'Application(s)',
    APPLY_BUTTON_TEXT: 'Apply',
    APPLY_TO_ALL_BUTTON_TEXT: 'Apply to all',
    ARE: 'are',
    BANDWIDTH: 'Bandwidth',
    BETWEEN: 'between',
    BULK_DELETE_WARNING_HEADER: 'Bulk delete',
    BULK_DELETE_WARNING_PART_1: 'You are about to delete',
    BULK_DELETE_WARNING_PART_2: 'This action cannot be undone. Do you want to proceed?',
    BULK_UPDATE_ERROR_CONTENT: 'Invalid selected header',
    BULK_UPDATE_FAILED: 'Bulk update failed',
    BULK_UPDATE_FIELD_SELECTION_PLACEHOLDER: 'Select field to update',
    BULK_UPDATE_INPUT_PLACEHOLDER: 'Updated value',
    BULK_UPDATE_SUCCESS_HEADING: 'updated successfully.',
    CALCULATE_BUTTON_TEXT: 'Calculate',
    CANCEL_BUTTON_TEXT: 'Cancel',
    CLOSE: 'Close',
    CLOSE_BUTTON_TEXT: 'Close',
    CONFIRM_BUTTON_TEXT: 'Confirm',
    CONTINUE_BUTTON_TEXT: 'Continue',
    COMING_SOON: 'Coming soon...',
    COMING_SOON_2: ' (what we’re building)',
    COPY_BUTTON_TEXT: 'Copy',
    CREATE_BUTTON_TEXT: 'Create',
    DATABASE: 'Database',
    DATABASE_LOWERCASE: 'database',
    DATABASES: 'Databases',
    DATABASE_S: 'Database(s)',
    DATABASES_LOWERCASE: 'databases',
    DEFAULT: 'Default',
    ALL_CAPITALIZED: 'ALL',
    DELETE_ALL_WARNING: 'You are about to delete ',
    DELETE_ALL_WARNING_HEADER: 'Delete ',
    DELETE_BUTTON_TEXT: 'Delete',
    DEPENDENCIES: 'Dependencies',
    DETAILS: 'Details',
    DISMISS_MESSAGE: 'Dismiss message',
    DROPDOWN: 'Dropdown',
    EDIT_BUTTON_TEXT: 'Edit',
    FALSE: 'False',
    EDIT_PROPERTIES_BUTTON_TEXT: 'Edit properties',
    FILTERED: 'filtered',
    FRICTION_ERROR_TEXT: 'Type {0} to confirm this action',
    FRICTION_HINT_TEXT_PART_1: 'To confirm this action, please type ',
    FRICTION_HINT_TEXT_PART_2: ' below',
    FROM: 'from',
    GET_STARTED_BUTTON_TEXT: 'Get started',
    HAS: 'has',
    HAVE: 'have',
    IMPORT_MORE_DATA_ACTION_BUTTON_TEXT: 'Import more records',
    INVALID_INPUT_FORMAT: 'Invalid input format',
    INVALID_INPUT_FORMAT_DESCRIPTION: 'Please check the input before saving.',
    INVALID_PORTFOLIO_ID_ERROR: 'Invalid portfolio ID',
    IS: 'is',
    LOAD_BUTTON: 'Load',
    MAPPED: 'Mapped',
    NA: 'N/A',
    NEXT_BUTTON_TEXT: 'Next',
    NO: 'No',
    NO_RESULTS_TO_DISPLAY: 'No results to display',
    NUMBER: 'Number',
    OF_TEXT: 'of',
    ON: 'On',
    OPEN: 'Open',
    ORACLE_STANDARD_DATABASE: 'Oracle BYOL Standard edition database',
    ORACLE_STANDARD_DATABASES: 'Oracle BYOL Standard edition databases',
    ORACLE_STANDARD_ONE_TWO_DATABASE: 'Oracle BYOL Standard One/Two edition database',
    ORACLE_STANDARD_ONE_TWO_DATABASES: 'Oracle BYOL Standard One/Two edition databases',
    PHONE_NUMBER_INVALID: 'Phone number invalid. If entering a non-US number, please add the country code.',
    PORTFOLIO_ASSESSMENT_GUIDE: 'Application portfolio assessment guide',
    PREFERENCE_HEADER: 'Preferences',
    PREVIOUS_BUTTON_TEXT: 'Previous',
    PROCEED: 'Proceed',
    QUANTITY: 'Quantity',
    RECORD: 'record',
    REMOVE_BUTTON_TEXT: 'Remove',
    RESOURCES: 'Resources',
    SAVE_AND_APPLY: 'Save and apply',
    SAVE_AS_BUTTON_TEXT: 'Save as...',
    SAVE_AS_NEW: 'Save as new',
    SAVE_BUTTON_TEXT: 'Save',
    SAVE_OVER_EXIST: 'Save over existing',
    SEARCH: 'Search',
    SELECTED: 'selected',
    SEND_BUTTON_TEXT: 'Send',
    SERVER_LOWERCASE: 'server',
    SERVER: 'Server',
    SERVERS: 'Servers',
    SERVER_S: 'Server(s)',
    SHARE_BUTTON_TEXT: 'Share',
    SOFTWARE: 'Software',
    SORT_BY: 'Sort By:',
    STATUS: 'Status',
    STEP_TEXT: 'Step',
    SUCCESS: 'Success',
    TEXT: 'Text',
    THE: 'the',
    THIS_ACTION_CANNOT_BE_UNDONE: 'This action cannot be undone',
    TO: 'to',
    TOGGLE_IN: 'toggle in',
    TRUE: 'True',
    UNABLE_TO_RETRIEVE: 'Unable to retrieve',
    UNKNOWN: 'Unknown',
    UNMAPPED: 'Unmapped',
    UPDATE_BUTTON_TEXT: 'Update',
    USER_GUIDE: 'MPA user guide',
    YES: 'Yes',
};

const contactManagementConstants = {
    ADD_CONTACT: 'Add contact',
    ADD_NEW_CONTACT: 'Add new contact',
    APPLICATION_MAPPING_CANNOT_BE_UPDATED: 'Application mapping cannot be updated',
    ASSIGN_OWNER_TIP: 'Assign owner to the selected servers/applications/databases',
    ASSIGN_OWNERSHIP: 'Assign ownership',
    BUTTON_TO_ADD_CONTACTS: 'button to add contacts.',
    CHARACTERS: 'characters',
    CLICK_THE: 'Click the',
    CONTACTS: 'Contacts',
    DATA: 'data',
    DATA_ON_THE: 'data on the',
    DATABASE_MAPPING_CANNOT_BE_UPDATED: 'Database mapping cannot be updated',
    DELETE_CONTACT: 'Delete contact',
    DELETE_CONTACT_CONFIRM: 'Are you sure you want to delete this contact?',
    EDIT_CONTACT: 'Edit contact',
    EMAIL_IN_USE: 'Email address is already in use',
    IMPORT_DATA_MSG_P1: 'You have yet to import',
    IMPORT_YOUR_DATA: 'Import your data',
    NAME_CANNOT_EXCEED_MSG: 'Name cannot exceed',
    NO_CONTACT_DATA: 'You do not have any contact data.',
    NO_CONTACT_DATA_FOUND: 'No contact data found.',
    PAGE: 'page',
    PHONE: 'Phone',
    PLEASE_IMPORT: 'Please import',
    QUESTIONNAIRE_ALREADY_EXISTS: 'A questionnaire has been created for this asset by another user. Changes in questionnaire ownership ' +
        'can only happen when no questionnaire exists or by the user who created the questionnaire.',
    SERVER_MAPPING_CANNOT_BE_UPDATED: 'Server mapping cannot be updated',
    START_DATA_REQUEST: 'Start data request',
    THIS_CONTACT_WILL_BE_UNASSIGNED: 'The contact will be unassigned from {0} servers, {1} applications, and {2} databases.' +
        'This action cannot be undone.',
    UNABLE_TO_CHANGE_OWNERSHIP: 'Unable to change ownership for selected',
};

const dataCollectionConstants = {
    ADD_QUESTION: 'Add question',
    ALREADY_SENT: ' has already been sent',
    ALREADY_SENT_PLURAL: ' have already been sent',
    APPLICATION_NAME: 'Application name',
    BUSINESS_APPLICATION: 'Business application',
    BUSINESS_OWNER_EMAIL: 'Business owner email',
    BUSINESS_OWNER_NAME: 'Business owner name',
    BUSINESS_OWNER_PHONE: 'Business owner phone',
    CANCEL_REQUEST: 'Cancel selected request(s) in progress',
    DELETE_QUESTION: 'Delete question?',
    DATABASE_OWNER_EMAIL: 'Database owner email',
    DATABASE_OWNER_NAME:  'Database owner name',
    DATABASE_OWNER_PHONE: 'Database owner phone',
    DUE_DATE: 'Due Date',
    DUE_DATE_MUST_BE_A_FUTURE_DATE: 'Due date must be a future date',
    EDIT_QUESTIONNAIRE_TEMPLATE: 'Edit questionnaire template',
    EMAIL_SUBJECT: 'You have new questionnaires',
    EMAIL_BODY: 'Greetings,\n\nYou have new questionnaire/s. Visit {0} to view and answer your questionnaire/s.\n' +
        'If you don’t have an account, please use as your email address when you sign up.\n\n' + 
        'Why am I receiving this email?\n' +
        'Business data gathering is a tool used by AWS and Partner teams to collect data in a consistent ' +
        'and secure manner to accelerate the assessment process.\n' +
        'You have been identified as a SME of an asset, and the team has requested more data on the asset.\n\n' +
        'Thanks\n',
    ERROR_ADDING_QUESTION: 'Unable to add question',
    ERROR_ALREADY_SENT: 'Questionnaires can only be sent once',
    ERROR_CREATING_QUESTIONNAIRE: 'Unable to create questionnaire',
    ERROR_DELETING_QUESTION: 'Unable to delete question',
    ERROR_DELETING_QUESTIONNAIRE: 'Failed to delete questionnaire',
    ERROR_LOADING_PROPERTY_OPTIONS: 'Error loading property options',
    ERROR_LOADING_QUESTIONS: 'Failed to load questions',
    ERROR_NO_CONTACT: 'Questionnaires cannot be sent for resources that do not have owners',
    ERROR_RETRIEVING_TEMPLATE: 'Unable to retrieve questionnaire template',
    ERROR_SAVING_TEMPLATE: 'Unable to save questionnaire template',
    ERROR_UPDATING_QUESTION: 'Unable to update question',
    ERROR_UPDATING_QUESTIONNAIRE: 'Failed to update questionnaire',
    LABEL: 'Label',
    SEND_REQUEST: 'Send selected request(s)',
    NEW_QUESTION: 'New question',
    NO_DATA: 'No data',
    NO_OWNER: ' do not have an owner',
    NO_OWNER_PLURAL: ' does not have an owner',
    NOT_STARTED: 'Not started',
    PLEASE_IMPORT_APPLICATIONS: 'Please import applications on the ',
    PLEASE_IMPORT_DATABASES: 'Please import databases on the ',
    PLEASE_IMPORT_SERVERS: 'Please import servers on the ',
    PLEASE_SELECT_A_QUESTIONNAIRE_TO_DELETE: 'Please select at least one questionnaire to delete request',
    PLEASE_SELECT_A_QUESTIONNAIRE_TO_SEND: 'Please select at least one questionnaire to send request',
    PROPERTY: 'property',
    QUESTION_LABEL: 'Question label',
    QUESTION_TEXT: 'Question text',
    QUESTION_TYPE: 'Question type',
    QUESTIONNAIRE_TEMPLATE: 'questionnaire template',
    QUESTIONNAIRES_DELETED: 'Questionnaires deleted',
    QUESTIONNAIRES_SENT: 'Questionnaires sent',
    REQUEST_STATUS: 'Request status',
    SEND_QUESTIONNAIRE_EMAIL_HEADER: 'Send questionnaire notification email',
    SEND_QUESTIONNAIRE_EMAIL_MSG1: 'Your selected questionnaires are now visible to the assigned users in the business data gathering tool.',
    SEND_QUESTIONNAIRE_EMAIL_MSG2: 'They can sign up and login at ',
    SEND_QUESTIONNAIRE_EMAIL_MSG3: 'You can now send them an email notification regarding their assigned questionnaires',
    SERVER_OWNER_EMAIL: 'Server owner email',
    SERVER_OWNER_NAME: 'Server owner name',
    SERVER_OWNER_PHONE: 'Server owner phone',
};

const attributeActionsConstants = {
    ADD_ATTRIBUTE_BUTTON_TEXT: 'Add attribute',
    ADD_ATTRIBUTE_CONFIRM_BUTTON_TEXT: 'Create attribute',
    ADD_ATTRIBUTE_DUPLICATE_ERROR: 'There is already an attribute with a similar name. Please specify a different name.',
    ADD_ATTRIBUTE_MODAL_HEADER: 'Configuration',
    ADD_ATTRIBUTE_UOM_HINT_FREQUENCY: 'Available UOMs are GHz, MHz, KHz, Hz.',
    ADD_ATTRIBUTE_UOM_HINT_RATIO: 'Available UOMs are Ratio and Percentage.',
    ADD_ATTRIBUTE_UOM_HINT_STORAGE: 'Available UOMs are TB, GB, MB, KB, Byte.',
    ATTRIBUTE_NAME_FORM_DESCRIPTION: 'Create a short, descriptive name for your attribute',
    ATTRIBUTE_NAME_FORM_LABEL: 'Attribute name*',
    ATTRIBUTE_TYPE_FORM_LABEL: 'Attribute type*',
    ATTRIBUTE_TYPE_RADIO_BUTTON_FREQUENCY: 'Frequency',
    ATTRIBUTE_TYPE_RADIO_BUTTON_GENERAL: 'General',
    ATTRIBUTE_TYPE_RADIO_BUTTON_RATIO: 'Ratio/percentage',
    ATTRIBUTE_TYPE_RADIO_BUTTON_STORAGE: 'Storage/memory',
    DATA_TYPE_FORM_DESCRIPTION: 'Data type is for your guidance only, currently not enforced',
    DATA_TYPE_FORM_LABEL: 'Data type*',
    DATA_TYPE_RATIO_BUTTON_BOOLEAN: 'Boolean',
    DATA_TYPE_RATIO_BUTTON_NUMBER: 'Number',
    DATA_TYPE_RATIO_BUTTON_TEXT: 'Text',
    DELETE_ATTRIBUTE_BUTTON_TEXT: 'Delete attribute',
    DELETE_ATTRIBUTE_CONFIRM_ERROR_1: 'Type ',
    DELETE_ATTRIBUTE_CONFIRM_ERROR_2: ' to confirm this action.',
    DELETE_ATTRIBUTE_CONFIRM_HINT_1: 'To confirm this action, please type ',
    DELETE_ATTRIBUTE_CONFIRM_HINT_2: ' below:',
    DELETE_ATTRIBUTE_CONFIRM_INPUT: 'delete',
    DELETE_ATTRIBUTE_EMPTY_SCHEMA_ERROR: 'No schema has been selected.',
    DELETE_ATTRIBUTE_FAILED: 'Failed to delete schema.',
    DELETE_ATTRIBUTE_FORM_LABEL: 'Choose schema',
    DELETE_ATTRIBUTE_MODAL_HEADER: 'Delete attribute?',
    DELETE_ATTRIBUTE_NOTES: 'Please note that this action is irreversible and will also remove corresponding portfolio data.',
    DELETE_ATTRIBUTE_SUCCESS: 'Successfully deleted schema.',
};

const migrationStrategyCountConstants = {
    CALC_DATABASE: 'Calculated database count',
    CALC_SERVER: 'Calculated server count',
    COUNTS_HEADER: 'Migration strategy counts',
    OVERRIDE_DATABASE: 'Overridden database count',
    OVERRIDE_SERVER: 'Overridden server count',
    TOTAL: 'Total',
};

const migrationStrategyConstants = {
    APPLICATION_MIGRATION_STRATEGY: 'Application migration strategy',
    BULK_UPDATE_MISSING_VALUES: 'Update value and selected servers are both required.',
    ERROR_UPDATING_MIGRATION_STRATEGY: 'Unable to update migration strategy data',
    MIGRATION_STRATEGIES: 'Migration strategies',
    MIGRATION_STRATEGY_INFO_P1: 'We assess your portfolio to determine the optimal Migration strategy. On this page you can see a summary and '
        + 'details of the Migration strategy that we have identified for each server. You may also override a Migration '
        + 'Strategy on a per server basis.',
    MIGRATION_STRATEGY_INFO_P2_START: 'Note: The',
    MIGRATION_STRATEGY_INFO_P2_MIDDLE: ' (VMware Cloud on AWS) strategy is limited to certain regions and is not '
        + 'enabled by default. In supported regions, you can enable',
    MIGRATION_STRATEGY_INFO_P2_END: ' under \'General assumptions\'.',
    OVERRIDE_INFO: 'To bulk update server migration strategy, please select rows to update and choose a new migration strategy.',
    OVERRIDE_MIGRATION_STRATEGY: 'Override migration strategy',
    RECALCULATE_ALERT: 'You have updated the migration strategy. Recalculate to update the assessment with these changes.',
    RELOCATE: 'Relocate',
    SELECT_OVERRIDE_STRATEGY: 'Select new migration strategy:',
    SERVER_MIGRATION_STRATEGY: 'Server migration strategy',
};

const migrationStrategySummaryConstants = {
    ADDITIONAL_COSTS: 'Additional costs',
    AWS_OFFSHORE_RESOURCES: 'AWS offshore resources',
    AWS_PROJECT_MGMT_COST: 'AWS project management cost',
    AWS_RESOURCE_COST: 'AWS resource cost',
    AWS_RESOURCES: 'AWS resources',
    AWS_RESOURCES_COST: 'AWS resources cost',
    AWS_RESOURCES_COUNT: 'AWS resources (#)',
    AWS_SENIOR_OFFSHORE_RESOURCES: 'AWS senior offshore resources',
    AWS_SENIOR_RESOURCES: 'AWS senior resources',
    CASH_FLOW_DETAILS: 'Cash flow details',
    CHANGE_LOCATION_WARNING_P1: 'Changing the migration project location will overwrite some migration assumption values that you might have updated.',
    CHANGE_LOCATION_WARNING_P2: 'Continuing this step will trigger recalculation of the assessment. Do you want to proceed?',
    COST: 'Cost',
    COST_LOWERCASE: 'cost',
    CUSTOMER: 'Customer',
    CUSTOMER_PROJECT_MGMT_COST: 'Customer project management cost',
    CUSTOMER_OFFSHORE_RESOURCES: 'Customer offshore resources',
    CUSTOMER_RESOURCE_COST: 'Customer resource cost',
    CUSTOMER_RESOURCES: 'Customer resources',
    CUSTOMER_RESOURCES_COST: 'Customer resources cost',
    CUSTOMER_RESOURCES_COUNT: 'Customer resources (#)',
    CUSTOMER_SENIOR_OFFSHORE_RESOURCES: 'Customer senior offshore resources',
    CUSTOMER_SENIOR_RESOURCES: 'Customer senior resources',
    DATABASE_RESOURCES: 'Database resources',
    DATABASE_SPRINT_TEAM_RESOURCES: 'Database sprint team resources',
    DISCOVERY_TOOL: 'Discovery tool',
    EDIT_RESOURCES: 'Edit resources',
    ERROR_DOWNLOADING_MIGRATION_ASSESSMENT: 'Failed to download migration assessment',
    ESTIMATED_MIGRATION_COST: 'Estimated On-Premises to AWS Migration Project Cost',
    HOUR_ABV: 'Hr',
    ITEM: 'Item',
    ITEM_LOWERCASE: 'item',
    LOCATION_NOT_SET_WARNING: 'Recalculate to customize the project location.',
    MIGRATION_COST: 'Migration cost',
    MIGRATION_DURATION: 'Migration Project duration',
    MIGRATION_LOCATION: 'Migration project location',
    MIGRATION_PATTERN: 'Migration pattern',
    MIGRATION_TOOL: 'Migration tool',
    MONTHS: 'Months',
    NUMBER_ONLY_MSG: 'Please input a number',
    OVERRIDE_RATES: 'Override rates',
    OVERRIDE_RESOURCES: 'Override resources',
    PARTNER: 'Partner',
    PARTNER_OFFSHORE_RESOURCES: 'Partner offshore resources',
    PARTNER_PROJECT_MGMT_COST: 'Partner project management cost',
    PARTNER_RESOURCE_COST: 'Partner resource cost',
    PARTNER_RESOURCES: 'Partner resources',
    PARTNER_RESOURCES_COST: 'Partner resources cost',
    PARTNER_RESOURCES_COUNT: 'Partner resources (#)',
    PARTNER_SENIOR_OFFSHORE_RESOURCES: 'Partner senior offshore resources',
    PARTNER_SENIOR_RESOURCES: 'Partner senior resources',
    RATE: 'Rate',
    RECALCULATE_DATABASE_WARNING: 'Recalculate to update the assessment with database changes.',
    RECALCULATE_PORTFOLIO_WARNING: 'Recalculate the portfolio to view estimated migration cost.',
    RESET_MIGRATION_VALUES: 'Reset migration resource count and cost values',
    RESOURCE: 'Resource',
    RESOURCE_COST_DISTRIBUTION: 'Resource cost distribution',
    RESOURCE_COUNT_DISTRIBUTION: 'Resource count distribution',
    SERVER_RESOURCES: 'Server resources',
    SERVER_SPRINT_TEAM_RESOURCES: 'Server sprint team resources',
    SHOW_HIDE_COLUMN: 'Show/hide columns',
    STRATEGY: 'Strategy',
    TOOLS_AND_TRAINING: 'Tools and training',
    TOOLS_TRAINING: 'Tools/Training',
    TOTAL_COST_DISTRIBUTION: 'Total cost distribution',
    TOTAL_ESTIMATED_MIGRATION_COST: 'Your Total Estimated Migration Cost',
    TOTAL_MIGRATION_COST: 'Total migration cost',
    TOTAL_RESOURCE_COST: 'Total resource cost',
    TOTAL_SPRINTS_REQUIRED: 'Total sprints required',
    TOTAL_SPRINT_TEAMS: 'Total sprint teams required',
    TOOLS_TRAINING_OTHER_COST: 'Tools/Training and other costs',
    TRAINING: 'Training',
    YEARS: 'Years',
};

const migrationStrategyCashflowConstants = {
    AWS_COST_WITH_MIGRATION: 'AWS cost with migration',
    COMPLETION_PLAN_POPOVER: 'AWS usage will increase and On-Premises usage will decrease over the migration project duration.',
    COMPLETION_PLAN_WARNING: 'Total distribution must sum to a total of 100% and each input must be non-negative and have no '
        + 'more than two (2) decimals places. The current total is ',
    COST_IN: 'Cost in',
    COST_WITH_MIGRATION: 'Cost with migration (moving to AWS)',
    COST_WITHOUT_MIGRATION: 'Cost without migration (remaining On-Premises)',
    INVALID_DISTRIBUTION: 'Invalid distribution',
    MIGRATION_CASH_FLOW_HEADER: 'Estimated migration project cash flow',
    MIGRATION_COMPLETION_PLAN: 'Migration completion plan',
    MIGRATION_COMPLETION_PLAN_DESCRIPTION: 'Distribute the migration cost percentage over the migration project duration below.',
    MONTH: 'Month',
    ON_PREM_COST_WITH_MIGRATION: 'On-Premises cost with migration',
    QUARTER: 'Quarter',
    RECALCULATE_MESSAGE: 'Recalculate the portfolio to view estimated cash flows.',
    TIMELINE_IN: 'Timeline in',
    TOTAL_COST_WITH_MIGRATION: 'Total cost with migration',
    TOTAL_ON_PREM_WITHOUT_MIGRATION: 'Total On-Premises cost without migration',
};

const tcoExcludedServersAlertConstants = {
    MARKED_OUT_OF_SCOPE_WARNING: 'marked as out of scope. You can update the \'In Scope of Portfolio\' server attribute on the Server '
        + 'data page to include or exclude server from analysis.',
    MARKED_RETAIN_WARNING: 'Retain migration strategy. '
        + 'You can update the \'Migration strategy\' attribute on the \'Migration strategy\' page to mark or un-mark servers as Retain.',
    MARKED_RETIRE_WARNING: 'Retire migration strategy. '
        + 'You can update the \'Migration strategy\' attribute on the \'Migration strategy\' page to mark or un-mark servers as Retire.',
    SERVERS_EXCLUDED_HEADER: 'Summary of servers excluded from analysis'
};

const createNewPortfolioConstants = {
    ACCOUNT_CREATE_NEW: 'Create new',
    ACCOUNT_ID: 'Account ID',
    ACCOUNT_LOADING: 'Loading accounts',
    ACCOUNT_NAME: 'Account name',
    ACCOUNT_NO_MATCH_FOUND: 'No matches found',
    ACCOUNT_OWNER: 'Owner',
    ACCOUNT_REFERENCE_ID: 'Account reference ID',
    ACCOUNT_REFERENCE_ID_DESP: 'An identifier for this account.',
    ACCOUNT_REFERENCE_ID_PLACEHOLDER: 'Reference ID',
    ACCOUNT_TERRITORY: 'Territory',
    ACCOUNT_USE_EXISTING: 'Use existing',
    CLASSIFY_CUSTOMER_DATA_DESP: 'This portfolio contains (or will contain) customer data.',
    CLASSIFY_CUSTOMER_DATA_LABEL: 'Customer data',
    CLASSIFY_TEST_DATA_DESP: 'Data stored in this portfolio is for testing or demonstration purposes and is not actual customer data.',
    CLASSIFY_TEST_DATA_LABEL: 'Test (or non-customer) data only',
    CREATE_A_NEW_PORTFOLIO: 'Create a new portfolio',
    CREATE_PORTFOLIO: 'Create portfolio',
    CREATE_PORTFOLIO_ACCOUNT_SETTINGS: 'Customer account settings',
    CREATE_PORTFOLIO_CLASS_DESP: 'Please help us to improve our analytics by indicating whether or not this portfolio will contain customer data.',
    CREATE_PORTFOLIO_CLASS_LABEL: 'Data classification',
    CREATE_PORTFOLIO_DATA_HEADER: 'Portfolio data',
    CREATE_PORTFOLIO_DESCRIPTION: 'Portfolios are containers where you store your customers\' IT data, migration plans and TCO assessments.',
    CREATE_PORTFOLIO_ERROR: 'Unable to create portfolio',
    CREATE_PORTFOLIO_NAME: 'Portfolio name*',
    CREATE_PORTFOLIO_NAME_DESP: 'Enter a descriptive name for your new portfolio.',
    CREATE_PORTFOLIO_NAME_PLACEHOLDER: 'Portfolio name',
    CREATE_PORTFOLIO_PREPOP_DESP: 'Choose whether you would like your portfolio to be created empty or with sample data.',
    CREATE_PORTFOLIO_PREPOP_LABEL: 'Initial dataset',
    CREATE_PORTFOLIO_SETTINGS_HEADER: 'Portfolio settings',
    CUSTOMER_ACCOUNT_NAME: 'Account name*',
    CUSTOMER_ACCOUNT_NAME_DESP: 'The name of the customer account associated with this portfolio.',
    CUSTOMER_ACCOUNT_NAME_PLACEHOLDER: 'Account name',
    CUSTOMER_ACCOUNT_NOT_FOUND: 'No customer account found.',
    PREPOP_EMPTY_DESP: 'Creates an empty portfolio. You can populate it later by importing from an Excel or CSV file.' +
        'Alternatively, you can import directly from the AWS Application Discovery Service (ADS).',
    PREPOP_EMPTY_LABEL: 'No data (empty)',
    PREPOP_SAMPLE_DESP: 'Prepopulates the portfolio with sample data. This data is useful for demonstration or experimentation purposes.',
    PREPOP_SAMPLE_LABEL: 'Sample data',
    SALESFORCE_DESP: 'Associate an account to your new portfolio by selecting the appropriate customer account from Salesforce.',
    SALESFORCE_ID: 'Salesforce ID*',
    SALESFORCE_ID_PLACEHOLDER: 'Salesforce ID',
    SEARCH_ACCOUNT_PLACEHOLDER: 'Search customer account by name (For example, acme).',
    SEARCH_ACCOUNT_TABLE_HEADER: 'Customer account',
    SEARCH_SALESFORCE: 'Search Salesforce',
    SELECT_CUSTOMER_ACCOUNT: 'Select customer account',
    SELECT_CUSTOMER_ACCOUNT_HINT1: 'Search for the customer account in the database.',
    SELECT_CUSTOMER_ACCOUNT_HINT2: 'Once you find the customer account, select the radio button next to their name and click \'Confirm\'.',
    SELECT_CUSTOMER_ACCOUNT_HINT3: 'If you cannot find the customer you are looking for, you can create the account in',
    SELECT_FROM_SALESFORCE: 'Select customer account from Salesforce',
};

const editPortfolioConstants = {
    EDIT_PORTFOLIO_HEADER: 'Edit portfolio properties',
    EDIT_PORTFOLIO_DESP: 'Edit the properties of your portfolio.',
    EDIT_PORTFOLIO_PROPERTIES_HEADER: 'Portfolio properties',
    EDIT_PORTFOLIO_NAME_LABEL: 'Portfolio name',
    EDIT_PORTFOLIO_NAME_DESP: 'Enter a descriptive name for your portfolio.',
    EDIT_PORTFOLIO_TEST_LABEL: 'Is this a test portfolio?',
    EDIT_PORTFOLIO_TAGS_HEADER: 'Portfolio tags',
};

const profileTagEditorConstants = {
    TAG_EDITOR_KEY_PLACEHOLDER: 'Enter key',
    TAG_EDITOR_VALUE_PLACEHOLDER: 'Enter value',
    TAG_EDITOR_ADD_BUTTON: 'Add new tag',
    TAG_EDITOR_REMOVE_BUTTON: 'Remove',
    TAG_EDITOR_UNDO_BUTTON: 'Undo',
    TAG_EDITOR_UNDO_PROMPT: 'This tag will be removed upon saving changes',
    TAG_EDITOR_LOADING: 'Loading tags that are associated with this portfolio',
    TAG_EDITOR_UPDATING: 'Updating tags that are associated with this portfolio',
    TAG_EDITOR_KEY_HEADER: 'Key',
    TAG_EDITOR_VALUE_HEADER: 'Value',
    TAG_EDITOR_OPTIONAL: 'optional',
    TAG_EDITOR_KEY_SUGGESTION: 'Custom tag key',
    TAG_EDITOR_VALUE_SUGGESTION: 'Custom tag value',
    TAG_EDITOR_EMPTY_TAGS: 'No tags associated with the resource.',
    TAG_EDITOR_TOO_MANY_KEYS_SUGGESTION: 'You have more keys than can be displayed',
    TAG_EDITOR_TOO_MANY_VALUES_SUGGESTION: 'You have more values than can be displayed',
    TAG_EDITOR_KEYS_SUGGESTION_LOADING: 'Loading tag keys',
    TAG_EDITOR_KEYS_SUGGESTION_ERROR: 'Tag keys could not be retrieved',
    TAG_EDITOR_VALUES_SUGGESTION_LOADING: 'Loading tag values',
    TAG_EDITOR_VALUES_SUGGESTION_ERROR: 'Tag values could not be retrieved',
    TAG_EDITOR_EMPTY_KEY_ERROR: 'You must specify a tag key',
    TAG_EDITOR_MAX_KEY_CHAR_LENGTH_ERROR: 'The maximum number of characters you can use in a tag key is 128.',
    TAG_EDITOR_MAX_VALUE_CHAR_LENGTH_ERROR: 'The maximum number of characters you can use in a tag value is 256.',
    TAG_EDITOR_DUPLICATE_KEY_ERROR: 'You must specify a unique tag key.',
    TAG_EDITOR_INVALID_KEY_ERROR: 'Invalid key. Keys can only contain alphanumeric characters, spaces and any of the following: _.:/=+@-',
    TAG_EDITOR_INVALID_VALUE_ERROR: 'Invalid value. Values can only contain alphanumeric characters, spaces and any of the following: _.:/=+@-',
    TAG_EDITOR_AWS_PREFIX_ERROR: 'Cannot start with aws:',
    TAG_EDITOR_TAG_LIMIT: 'You can add up to {0} more tag',
    TAG_EDITOR_TAG_LIMIT_REACHED: 'You have reached the limit of {0} tag',
    TAG_EDITOR_TAG_LIMIT_EXCEEDED: 'You have exceeded the limit of {0} tag',
    TAG_EDITOR_ENTERED_KEY_VALUE_LABEL:  'Use "{0}"',
    TAG_EDITOR_ADD_SAP_TAGS: 'Add SAP tags',
    TAG_EDITOR_SAP_ARR: 'SAP ARR',
    TAG_EDITOR_SAP_REPORTING: 'For SAP reporting',
    TAG_EDITOR_SFDC_OPPORTUNITY_ID: 'SFDC Opportunity Id',
    TAG_EDITOR_SPECIALIZED_WORKLOAD_SAP: 'Specialized Workload SAP',
    TAG_EDITOR_SPECIALIZED_WORKLOAD_ORACLE: 'Specialized Workload Oracle', 
    TAG_EDITOR_SPECIALIZED_WORKLOAD_MICROSOFT: 'Specialized Workload Microsoft',
    TAG_EDITOR_SPECIALIZED_WORKLOAD_VALUE_YES: 'Yes',
    TAG_EDITOR_SPECIALIZED_WORKLOAD_VALUE_NO: 'No',
};

const sharePortfolioConstants = {
    ACCESS_ALREADY_GRANTED: 'Access already granted',
    ACCESS_ALREADY_GRANTED_TO: ' access already granted to ',
    ACCESS_GRANTED_TO: 'Access granted to ',
    ACCESS_REVOKED: 'Access revoked to ',
    ACTION: 'Action',
    DISCARD_CHANGES: 'Discard changes',
    DISCARD_CHANGES_ALERT: 'Your changes will not be saved. To save your updates, click \'Cancel\' and apply the changes.',
    EMAIL: 'Email',
    EMAIL_ALERT_INFO: 'Sometimes people have multiple email addresses within the same company.' + 
        'Please ensure the entered email address is the one they use for MPA access; in particular, validate the domain name.',
    EMAIL_IS_THE_EXPECTED_ONE: 'Please ensure the email address is the expected one.',
    EMAIL_NOT_CONFORM_TO_PATTERN: 'Email should conform to [Email Address] pattern',
    EMAIL_NOT_FOUND: ' not found.',
    EMAIL_PLACEHOLDER: 'User email address (up to 254 characters)',
    EMAIL_TOO_LONG: 'Email is too long. Should be at most {0} characters',
    FAIL_TO_SEARCH_USER_BY_EMAIL: 'Failed to search user by email',
    FULL: 'Full',
    GRANTING_ACCESS: 'Granting access',
    INVITATION_CANCELED: 'Invitation to share portfolio with {0} is canceled',
    INVITATION_SENT_TO: 'Invitation sent to ',
    INVITED: 'Invited',
    LOADING_USER_ACCESS: 'Loading user access',
    MULTIPLE_EMAIL_FOUND: 'Multiple users found for ',
    MULTIPLE_EMAIL_PLEASE_SELECT: 'Please select user to grant permission for portfolio ',
    NAME: 'Name',
    NEW_USER_ACCESS: 'New user access:',
    ORGANIZATION: 'Organization',
    PENDING_ADD: 'Pending add',
    PENDING_DELETE: 'Pending delete',
    PENDING_INVITE: 'Pending invite',
    SAVED: 'Saved',
    UNABLE_TO_CANCEL: 'Unable to cancel invitation to access portfolio',
    UNABLE_TO_GET_ACCESS_PERMISSIONS: 'Unable to get portfolio permissions. Please check if you have full permission on this portfolio',
    UNABLE_TO_GRANT_ACCESS: 'Unable to grant access to portfolio',
    UNABLE_TO_INVITE: 'Unable to invite user to portfolio',
    UNABLE_TO_REVOKE: 'Unable to revoke access to portfolio',
    UNABLE_TO_REVOKE_LAST_EXISTING_FULL_ACCESS: 'Unable to revoke the last existing Full access',
    USER_ACCESS: 'Users allowed access:',
    VIEW: 'View',
    WOULD_YOU_LIKE_TO_INVITE: 'Would you like to invite {0} to access {1}?',
};

export const applicationGroupConstants = {
    ALERT_SELECTED_GROUP_LOCKED: 'The selected group is locked. Please unlock the group before changing group memberships.',
    ALERT_SELECT_ONE_MAPPING: 'Please unselect one application for every shared resource.',
    APPLICATION_COUNT: 'Dependent application count',
    APPLICATION_DATA_VALIDATED: 'Application data validated %',
    APPLICATION_GROUPS_TABLE_RESOURCE_NAME: 'Dependency groups',
    APPLICATION_GROUP_STATUS_CLOSED: 'Closed',
    APPLICATION_GROUP_STATUS_OPEN: 'Open',
    APPLICATIONS_FROM_TO: 'Applications - from {0} to {1}',
    CANNOT_REMOVE_DEP_BY_TYPE: 'Cannot remove dependencies by type',
    DATABASE_DATA_VALIDATED: 'Database data validated %',
    DATA_VALIDATED: 'Data validated %',
    DB_ASC: 'Database (ascending)',
    DB_DSC: 'Database (descending)',
    DATABASES_SHARED: 'Database(s) shared by both applications.',
    DEPENDENT_APP: 'Dependent application',
    DEPENDENCY_DETAIL: 'Dependency detail',
    ERROR_CREATING_GROUPS: 'Failed to create application groups',
    ERROR_LOADING_GROUPS: 'Failed to load application groups',
    ERROR_MARKING_AS_SHARED_INFRA: 'Failed to mark resource(s) as shared infrastructure',
    ERROR_RECREATING_GROUPS: 'Failed to recreate groups',
    ERROR_REMOVING_APPLICATION: 'Failed to remove application(s)',
    ERROR_UPDATING_GROUP_INFO: 'Failed to update application group info',
    ERROR_UPDATING_GROUP_STATUS: 'Failed to update application group status',
    ERROR_UPDATING_IN_REVIEW_DEPENDENCIES: 'Failed to update in-review dependencies',
    ERROR_UPDATING_SHARED_INFRA: 'Failed to update shared infrastructure',
    GROUP_DETAILS: 'Group Details',
    GROUP_NAME: 'Group name',
    GROUP_NAME_ERROR: 'Group name cannot be empty',
    HIDDEN_APPLICATION_S: 'Hidden Application(s)',
    HIDDEN_SERVERS_AND_DATABASES: 'Hidden Server(s) and Database(s)',
    HIDE_BUTTON_TEXT: 'Hide',
    IN_REVIEW_DEPENDENCIES: 'In-Review dependencies',
    MARK_AS_ACTIVE: 'Mark as active',
    MARK_AS_INACTIVE: 'Mark as inactive',
    MARK_AS_SHARED_BUTTON_TEXT: 'Mark As Shared',
    MARK_AS_SHARED_INFRASTRUCTURE: 'Mark as shared infrastructure',
    MARK_FOR_REVIEW: 'Mark for review',
    MARK_FOR_REVIEW_BUTTON_TEXT: 'Mark for review',
    MODIFIED: 'modified',
    NO_DEPENDENCIES_FOUND: 'No dependency found.',
    NUMBER_OF_APPLICATIONS: 'Number of applications',
    NUMBER_OF_DATABASES: 'Number of databases',
    NUMBER_OF_SERVERS: 'Number of servers',
    RECREATE_GROUPS_BUTTON_TEXT: 'Recreate groups',
    RECREATE_GROUPS_DROPDOWN_OPTION: '(Re)create Groups',
    RECREATE_GROUPS_WARNING: 'Taking this action will remove groups from assigned waves. You will need to re-assign them to waves after taking this action.',
    REGULAR_RESOURCE: 'Regular resource',
    REMOVE_APPLICATON: 'Remove Application',
    REMOVE_APPLICATION_MESSAGE_1: 'shares the following resources with the rest of',
    REMOVE_APPLICATION_MESSAGE_2: '. Please toggle off the dependencies this application can function without.',
    REMOVE_APPLICATONS: 'Remove applications',
    REMOVE_APPLICATONS_FROM_GROUP: 'Remove applications from group',
    REMOVE_APPLICATONS_FROM_GROUP_BUTTON_TEXT: 'Remove applications from group',
    REMOVE_APP_SELECTION_MESSAGE: 'Selected applications have the following shared resources with the rest of the group. Please uncheck the '
        + 'application(s) which can function without this dependency or can easily replicate the function on the new infrastructure.',
    REMOVE_DEPENDENCIES_BY_TYPE: 'Remove dependencies by type',
    RESOURCE_LOWERCASE: 'resource',
    RESOURCES_LOWERCASE: 'resources',
    SELECTED_APP: 'Selected application',
    SELECT_APP_TO_REMOVE: 'Select the application(s) that you want to remove from the group.',
    SERVER_ASC: 'Servers (ascending)',
    SERVER_DATA_VALIDATED: 'Server data validated %',
    SERVER_DB_ASC: 'Servers + databases (ascending)',
    SERVER_DB_DSC: 'Servers + databases (descending)',
    SERVER_DSC: 'Servers (descending)',
    SERVERS_SHARED: 'Server(s) shared by both applications.',
    SHARED_DATABASES: 'Shared databases',
    SHARED_INFRASTRUCTURE: 'Shared infrastructure',
    SHARED_SERVERS: 'Shared servers',
    STATUS: 'Status',
    UNHIDE_BUTTON_TEXT: 'Unhide',
    UPDATE_STATUS_DROPDOWN_LABEL: 'Update Status',
    WARNING_HEADER: 'Warning',
};

export const applicationGroupCompositionConstants = {
    AND: ' and',
    APPLICATION: 'Application',
    APPLICATION_LOWERCASE: 'application',
    APPLICATIONS: 'Applications',
    APPLICATIONS_LOWERCASE: 'applications',
    APPLICATION_GROUPING_TITLE: 'Dependency groups',
    ASSETS_TO_DISPLAY: 'Assets to display',
    CANNOT_INFER_DEPENDENCIES: 'Cannot infer application dependencies',
    DATABASES: 'Databases',
    DATA_REQUIRED: 'At a minimum, the following data is required to create dependency groups:',
    DEFAULT_VIEW: 'Default view',
    GRAPH_TITLE_NUMBER_OF: 'Number of',
    GRAPH_TITLE_PER_GROUP: 'per group',
    GROUPS_15: '15 groups',
    GROUPS_30: '30 groups',
    GROUPS_45: '45 groups',
    GROUPS_60: '60 groups',
    GROUP_NAME: 'Group name',
    NO_GROUPS_MESSAGE_1: 'Import data and click ',
    NO_GROUPS_MESSAGE_2: ' to visualize groups of dependent applications.',
    NUMBER_OF_APPLICATIONS: 'Number of applications',
    NUMBER_OF_DATABASES: 'Number of databases',
    NUMBER_OF_SERVERS: 'Number of servers',
    OUT_OF_BOUNDS_ERROR: 'Must be an integer from 1 to 1000',
    PREFERENCES_MODAL_HEADER: 'Application group visualization preferences',
    RANKING: 'Ranking',
    SERVER: 'Server',
    SERVERS: 'Servers',
    SERVERS_LOWERCASE: 'servers',
    SERVER_APP_MAPPING: 'Server to application mapping',
    SHOW_WAVE_CAPACITY: 'Show Wave Capacity',
    SORT_OPTIONS: 'Sort options',
    START_FROM_THE_BEGINNING: 'Start from the beginning',
    START_FROM_THE_BEGINNING_WARNING: '\'Start from the beginning\' will reset all dependencies and recreate application groups.',
    START_FROM_THE_BEGINNING_WARNING_WAVES:
        'Warning: taking this action will remove groups from assigned waves. You will need to re-assign them to waves after taking this action.',
};

const applicationGroupDetailConstants = {
    APPLICATION_GROUP_DETAIL: 'Application group detail',
    ERROR_LOADING_APPLICATION_DATABASE_MAPPING: 'Failed to load application database mapping',
    ERROR_LOADING_APPLICATION_DEPENDENCIES_MAPPING: 'Failed to load application dependencies',
    ERROR_LOADING_APPLICATION_GROUP_DETAIL: 'Failed to load application group detail',
    ERROR_LOADING_APPLICATION_SERVER_MAPPING: 'Failed to load application server mapping',
    ERROR_LOADING_SERVER_COMMUNICATION: 'Failed to load server communication',
    VISUALIZATION: 'Visualization',
};

const applicationGroupDependencyConstants = {
    DEPENDENCY_GRAPH: 'Dependency graph',
    HEATMAP: 'Heatmap',
};

const applicationGroupDependencyGraphConstants = {
    ACTIVE: 'Active',
    CONNECTED_APPS: 'Connected applications:',
    CONNECTED_DBS: 'Connected databases',
    CONNECTED_SERVERS: 'Connected servers:',
    DATABASE_DEPENDENCY: 'Database dependency',
    DATABASE_DEPENDENCIES: 'Database Dependencies',
    DEPENDENCY_TYPE: 'Dependency type',
    DEPENDENT_APPLICATION: 'Dependent application',
    INACTIVE: 'Inactive',
    IS_SHARED_INFRASTRUCTURE: 'Is shared infrastructure',
    NO_DATABASE_DEPENDENCIES: 'No Database Dependencies',
    NO_DEPENDENCY_TO_VISUALIZE: 'No dependency to visualize.',
    NO_SERVER_DEPENDENCIES: 'No Server Dependencies',
    RANKING: 'Ranking',
    RESOURCE_ID: 'Resource ID',
    RESOURCE_TYPE: 'Resource type',
    SERVER_COMMUNICATION: 'Server communication',
    SERVER_DEPENDENCY: 'Server dependency',
    SERVER_DEPENDENCIES: 'Server Dependencies',
    USER_IMPORTED_DEPENDENCY: 'User imported dependency',
};

const importADSConstants = {
    ACCESS_KEY_ID: 'Access key ID*',
    ACCESS_KEY_ID_PLACEHOLDER: 'Enter access key ID',
    ADS_CREDENTIALS_HEADER: 'AWS credentials',
    ADS_NOTE_1: 'MPA is not part of the AWS Management Console.',
    ADS_NOTE_2: 'Deleting data from ADS will not delete it from MPA.',
    ADS_NOTE_3: 'Importing duplicate data from ADS will overwrite the existing data in MPA.',
    ADS_NOTE_4: 'Importing duplicate data from a CSV or Excel file will overwrite the existing ADS data in MPA.',
    ADS_NOTE_5: 'Reimporting data from ADS will overwrite the existing records.',
    ADS_NOTE_6: 'You cannot import from multiple AWS accounts. Create a new portfolio if you want to import data from a different AWS account.',
    ADS_NOTE_7: 'As a best practice, create an IAM user with only the discovery:DescribeConfigurations and discovery:ListConfigurations actions'
        + ' and use its access key.',
    FAILED_TO_IMPORT_ADS: 'Failed to import ADS',
    IMPORT_FROM_ADS_BUTTON: 'Import from ADS',
    PLEASE_NOTE: 'Please note: ',
    REGION_LABEL: 'Region*',
    REGION_PLACEHOLDER: 'Select an AWS Region',
    SECRET_ACCESS_KEY: 'Secret access key*',
    SECRET_ACCESS_KEY_PLACEHOLDER: 'Enter secret access key',
    SUCCESSFULLY_IMPORT_ADS: 'Successfully imported ADS data from the given AWS account.'
};

const feedbackConstants = {
    FEEDBACK_PROVIDE_FEEDBACK: 'Provide feedback',
    FEEDBACK_SUBMIT_A_BUG: 'Submit a bug',
    FEEDBACK_SUGGEST_A_FEATURE: 'Suggest a feature',
    FEEDBACK_HAVE_FEEDBACK: 'Have feedback?',
    TELL_US_WHAT_YOU_THINK: 'Tell us what you think',
    FEEDBACK: 'Feedback'
};

const dataQualityConstants = {
    ADD_CLAUSE: 'Add clause',
    ADD_NEW_RULE: 'Add new rule',
    AND_UPPERCASE: 'AND',
    ANY_SEVERITY: 'Any severity',
    ATTRIBUTE: 'Attribute',
    CLAUSE_BUILDER: 'Clause builder',
    CONTAINS: 'Contains',
    COPY_RULE_HEADER: 'Import rules from another portfolio',
    CREATE_RULE_SUCCESS: 'Rule successfully created!',
    CUSTOM: '(custom)',
    DATA_QUALITY_PREVIEW_HEADER: '\'Data validation rules\' is a preview feature',
    DEFAULT_RULE_NOTE: 'Note: input is disabled for default rules.',
    DELETE_RULE: 'Delete rule',
    DELETE_RULES: 'Delete rules',
    DESCRIPTION: 'Description',
    DESCRIPTION_NOTE: 'Describe how the new rule impacts the assessment',
    DISABLED: 'Disabled',
    DISABLED_RULES: 'disabled rules',
    DISABLE_RULE: 'Disable rule',
    DISABLE_RULES: 'Disable rules',
    DOES_NOT_CONTAIN: 'Does not contain',
    DOES_NOT_EXIST: 'Does not exist',
    DOWNLOAD_REPORT: 'Download report', 
    ENABLE_RULE: 'Enable rule',
    ENABLE_RULES: 'Enable rules',
    ERRORS_FOUND_DESCRIPTION:  'The issues below might negatively impact recommendations or calculations in one or more areas of the tool.'
        + 'Review these issues based on their severity and address any issues as needed.'
        + 'You may also edit the rules if appropriate.',
    ERRORS_FOUND_HEADER_0: 'We found ',
    ERRORS_FOUND_HEADER_1: 'possible validation issues in your',
    ERRORS_FOUND_HEADER_2: 'data',
    ERROR_COPYING_RULE: 'Error occurred while trying to copy ',
    ERROR_DELETING_RULE: 'Error occurred while trying to delete ',
    ERROR_DISABLING_RULES: 'Failed to disable rules',
    ERROR_ENABLING_RULES: 'Failed to enable rules',
    ERROR_LOADING_DESCRIPTION: 'One of the recent rules you created or updated might be the source.',
    ERROR_LOADING_HEADER: 'An error occurred loading rule data',
    ERROR_LOADING_IF_RULES_EXIST: 'Please try to edit the rule using the clause builder or disable the rule.',  
    ERROR_LOADING_RULES: 'Failed to load rules',
    ERROR_LOADING_USE_FEEDBACK: 'You can always let us know if the issue persists through the feedback link.',
    ERROR_LOADING_VALIDATION_SUMMARY: 'Failed to load rule validations',
    ERROR_LOADING_VALIDATION_SUMMARY_NOT_FOUND: 'Validation summary not yet available, please try again later',
    ERROR_REVALIDATING_RULES: 'Failed to revalidate rules',
    EVEN: 'Even',
    EXISTS: 'Exists',
    GROUP: 'Group',
    HIDE: 'Hide ',
    HIGH: 'High',
    IMPACT: 'Impact',
    IMPACT_AREA: 'Impact area',
    IMPACT_DESCRIPTION: 'Select the assessments impacted by the new rule and the associated severity level',
    IMPORT_RULES: 'Import rules', 
    IN: 'In',
    LOADING_PORTFOLIOS: 'Loading portfolios',
    LOADING_PORTFOLIOS_ERROR: 'Unable to retrieve portfolios',
    LOW: 'Low',
    MATCHES_REGULAR_EXPRESSION: 'Matches regular expression',
    MEDIUM_UPPERCASE: 'Medium',
    MIGRATION_COST: 'Migration cost',
    MISSING_RULE_DESCRIPTION: 'Missing rule description',
    MISSING_RULE_IMPACT: 'Missing rule impact',
    MISSING_RULE_NAME: 'Missing rule name',
    NA: 'N/A',
    NOT_IN: 'Not in',
    NO_CUSTOM_RULES: 'No custom rules found',
    NO_ERRORS_FOUND_DESCRIPTION: 'No errors were found.',
    NO_ERRORS_FOUND_HEADER_0: 'All',
    NO_ERRORS_FOUND_HEADER_1: 's pass the rule validation.',
    NO_PORTFOLIOS_FOUND: 'No portfolios available',
    NO_RULES_FOUND: 'No rules found',
    ODD: 'Odd',
    OPERATOR: 'Operator',
    OR: 'OR',
    PASSING_RULES: 'passing rules',
    PLANNING: 'Planning',
    RAW_SCHEMA: 'Raw schema',
    RAW_SCHEMA_EDIT_NOT_SUPPORTED: 'As of now, editing raw schemas is not supported.',
    REVALIDATE: 'Revalidate',
    RULE: 'rule',
    RULE_CAPITALIZED: 'Rule',
    RULE_CONFIGURATION: 'Rule configuration',
    RULE_COPY_ERROR_MSG: 'Cannot be copied due to existing rule with same name',
    RULE_COPY_WARNING_MSG: 'Rule has been copied previously and will be overwritten',
    RULE_FILTER_ERROR_MSG: 'Unable to filter by rule',
    RULE_NAME: 'Rule name',
    RULE_NAME_DESCRIPTION: 'Choose a short, descriptive name for your rule',
    SELECT_COPY_RULE_HEADER: 'Select rule(s) to copy into the current portfolio',
    SELECT_PORTFOLIO: 'Select a portfolio',
    SHOW: 'Show ',
    SHOW_RAW_SCHEMA: 'Show raw schema',
    STRATEGY: 'Strategy',
    SUCCESS_COPYING_RULES: 'Successfully copied ',
    SUCCESS_DELETING_RULE: 'Successfully deleted ',
    TCO: 'TCO',
    TOTAL_ISSUES: 'Total issues',
    UNKNOWN: 'Unknown',
    UPDATES_SUCCESSFULLY_SAVED: 'Updates successfully saved!',
    VALIDATION_RULE: 'Validation rule',
    VALIDATION_SUCCESS: 'Validation passed!',
    VALIDATE: 'Validate',
    VALUE: 'Value',
    WARNINGS: 'Warnings',
};

export const feedbackWindowConstants = {
    CANCEL: 'Cancel',
    COMMENT: 'Comment (optional):',
    COMMENT_PLACEHOLDER: 'Please provide additional comments here.',
    HEADER: 'How are we doing?',
    NEGATIVE: 'Negative',
    NEUTRAL: 'Neutral',
    POSITIVE: 'Positive',
    SUBMIT: 'Submit',
    FLASH_ERROR: 'Sorry, we were not able to submit your feedback. Please try again later. If this issue persists, please contact us at ',
    FLASH_SUCCESS_TITLE: 'Success',
    FLASH_INFO: 'Reporting...',
    REQUIRED_FIELD: 'Required field',
    CONTACT_EMAIL: 'proserve-mpa-tool@amazon.com',
    FEATURE_TITLE: 'MPA Feature Request -',
    BUG_TITLE: 'MPA Bug -',
    FEATURE_DESCRIPTION: 'Description:\r\nExpected Behavior:\r\nAdditional Info:',
    BUG_DESCRIPTION: 'Issue Description:\r\nExpected Behavior:\r\nObserved Behavior:\r\nAdditional Info:',
    BUG_HEADER: 'Submit issue',
    FEATURE_HEADER: 'Submit feature request',
    TITLE: 'Title *',
    SUCCESS_MESSAGE: 'Feedback is submitted successfully.',
};

const migrationWaveConstants = {
    ADD_A_WAVE: 'Add a wave',
    ADD_WAVES: 'Add waves',
    ADD_TO_WAVE: 'Add to wave',
    ANY_DAY_OF_WEEK: 'Any day of week',
    ASSIGNED_GROUPS: 'Assigned groups',
    ASSIGN_APPLICATION_GROUPS: 'Assign application groups',
    AUTO_CREATE_WAVES: 'Auto create waves',
    ASSET_CAPACITY: 'Asset capacity',
    CANNOT_ADD_GROUPS_TO_WAVE: 'Cannot add groups to wave',
    CANNOT_CREATE_WAVE: 'Cannot create wave(s)',
    CANNOT_DELETE_WAVE: 'Cannot delete wave',
    CANNOT_LOAD_WAVES: 'Cannot load migration waves',
    CANNOT_REMOVE_GROUPS_FROM_WAVE: 'Cannot remove groups from wave',
    CANNOT_UPDATE_WAVE: 'Cannot update wave',
    CHOOSE_ADD_WAVE_TYPE: 'Choose add wave type',
    CLOSED: 'Closed',
    CLOSED_FIRST: 'Closed first',
    COMMENTS: 'Comments',
    COMMENT_OPTIONAL: 'Comments (optional)',
    CREATE_WAVE: 'Create wave',
    DATABASE_ASCENDING: 'Databases ascending',
    DATABASE_DESCENDING: 'Databases descending',
    DATA_VALIDATION_PASSED: 'Data validation (% passed)',
    DATE_SHOULD_BE_EARLIER_THAN: 'Date must be earlier than',
    DATE_SHOULD_BE_LATER_THAN: 'Date must be later than',
    DELETE_EXISTING_WAVES: 'Delete existing waves',
    DOWNLOAD_WAVE_BUTTON: 'Download wave report',
    EDIT_WAVE: 'Edit wave',
    END_DATE: 'End date',
    END_DATE_ASCENDING: 'End date ascending',
    END_DATE_DESCENDING: 'End date descending',
    END_DATE_SHOULD_BE_LATER_THAN_START_DATE: 'End date must not be earlier than start date',
    GENERAL_SETTINGS: 'General settings',
    GROUPS: 'Groups',
    IN_PLANNING: 'In-Planning',
    MIGRATION_DATES: 'Migration dates',
    MIGRATION_END_DATE: 'Migration end date (estimate)',
    MIGRATION_START_DATE: 'Migration start date',
    MODIFY_RULES_FOR_VALIDATION: 'Modify data validation rules on the Server/Application/Database pages.',
    MONDAY: 'Monday',
    NAME_ASCENDING: 'Name ascending',
    NAME_DESCENDING: 'Name descending',
    NEXT_MONTH: 'Next month',
    NUMBER_OF_WAVES: 'Number of waves',
    NO_WAVES_MESSAGE_1: 'Wave planning allows you to create waves for migration application groups.',
    NO_WAVES_MESSAGE_2: 'Click ',
    NO_WAVES_MESSAGE_3: ' to create a migration wave plan.',
    OPEN_FIRST: 'Open first',
    PASSED_VALIDATION: 'passed validation',
    PLANNED: 'Planned',
    PREVIOUS_MONTH: 'Previous month',
    RANKING_ASCENDING: 'Ranking ascending',
    RANKING_DESCENDING: 'Ranking descending',
    REMOVE_FROM_WAVE: 'Remove from wave',
    REMOVE_GROUP_FROM_WAVE: 'Remove group from wave',
    SERVERS_ASCENDING: 'Servers ascending',
    SERVERS_DESCENDING: 'Servers descending',
    SHOW_ASSIGNED_GROUPS: 'Show assigned groups',
    START_DATE: 'Start date',
    START_DATE_ASCENDING: 'Start date ascending',
    START_DATE_DESCENDING: 'Start date descending',
    START_DATE_SHOULD_BE_EARLIER_THAN_END_DATE: 'Start date must not be later than end date',
    START_NEW_WAVE_ON: 'Start new wave on...',
    TODAY: 'Today',
    UNABLE_TO_DOWNLOAD_WAVES: 'Unable to download migration wave report',
    UNASSIGNED_GROUPS: 'Unassigned groups',
    WAVES: 'Waves',
    WAVE_DURATION_IN_WEEKS: 'Wave duration in weeks',
    WAVE_CAPACITY: 'Wave capacity',
    WAVE_NAME: 'Wave name',
    WAVE_PLANNING_TITLE: 'Wave planning',
    YOU_ARE_ABOUT_TO_REMOVE_GROUP_FROM_WAVE: 'You are about to remove {0} from {1}',
    YOU_ARE_ABOUT_TO_REMOVE_GROUPS_FROM_THEIR_WAVE: 'You are about to remove {0} group(s) from their migration wave(s)',
};

export const appName = 'Migration Portfolio Assessment';

const rdsRecommendationConstants = {
    ARE_SHOWN: 'are shown',
    AWS_DB_INSTANCE_TYPE_DETAILS: 'AWS database instance type details',
    AWS_DB_RECOMMENDATIONS: 'AWS RDS recommendations',
    EDITION: 'Edition',
    ERROR_LOADING_RDS_INSTANCE_TYPES: 'Failed to load RDS instance types',
    ERROR_LOADING_RDS_RECOMMENDATIONS: 'Error loading RDS recommendations',
    ERROR_OVERRIDING_RDS_RECOMMENDATION: 'Failed to override RDS recommendation',
    INSTANCE_TYPE: 'Instance type',
    ONLY_FIRST: 'only first',
    OVERRIDE_RDS_RECOMMENDATION: 'Override RDS recommendation',
    TARGET_DB_ENGINE: 'Target DB engine',
    UNMATCHED_DB_WARNING_P1: 'Please note: we were not able to find a match for the following',
    UNMATCHED_DB_WARNING_P2: 'They are excluded from the AWS database recommendations. Please review their attributes (\'Target AWS DB Service\', '
        + '\'DB Instance Engine/Software\', \'CPU-Number of Processors\', \'CPU-Cores per Processor\', \'RAM-Total Size\' ...), update and rerun the analysis.',
};

const rdsCostConstants = {
    AMAZON_DB: 'Amazon database',
    AMAZON_DB_RESIDUAL_VALUE: 'Amazon database residual value',
    AWS_DB_COST: 'AWS database cost',
    DATABASE_CASHFLOW: 'Database cash flow',
    DATABASE_ENGINE: 'Database Engine',
    DATABASE_LICENSING: 'Database licensing',
    DATABASE_PRICING_DETAIL: 'Database pricing details',
    DB_LICENSES: 'Database licenses - 3rd party',
    DB_LICENSE_COST: 'Database license cost',
    EDITION: 'Edition',
    ERROR_LOADING_RDS_ASSESSMENT: 'Failed to load the RDS assessment',
    INSTANCES: 'Instances',
    LICENSES: 'Licenses',
    PRICING_DETAILS: 'Pricing details',
    RDS_PREVIEW_TEXT: 'You can toggle inclusion in TCO calculation of RDS recommendations under \'Assumptions > AWS database recommendation\'. '
        + 'This has implications in all TCO aspects: if the toggle is Off, all servers are '
        + ' considered regular servers and database cost is not considered in AWS or On-Premises; if the toggle is On, RDS recommendations are '
        + ' determined, AWS and On-Premises database cost is calculated and the corresponding servers are accounted as database servers only, '
        + ' which reflects also in storage and IT labor costs for AWS and On-Premises.',
    RECOMMENDED_PAYMENT: 'Recommended payment',
    SUPPORT_COST: 'Support cost',
    VALUE_AFTER_TCO_DURATION: 'Value after TCO duration',
};

const tcoAwsStorageAndNetworkConstants = {
    AWS_DB_RECOMMENDATION: 'Database storage pricing',
    AWS_EBS_COLD_HDD: 'EBS - Cold HDD',
    AWS_EBS_GP: 'EBS - General Purpose',
    AWS_EBS_INIT_SNAPSHOT_COST: 'Initial snapshot cost',
    AWS_EBS_IOPS_COST: 'IOPS cost',
    AWS_EBS_PROVISIONED: 'EBS - Provisioned IOPS',
    AWS_EBS_SNAPSHOT_COST: 'Snapshot cost',
    AWS_EBS_SNAPSHOT_SIZE: 'Snapshot size (GB)',
    AWS_EBS_SUBS_SNAPSHOT_COST: 'Subsequent backup snapshot cost',
    AWS_EBS_THROUGHPUT: 'Throughput Optimized HDD',
    AWS_EBS_THROUGHPUT_COST: 'Throughput cost',
    AWS_EBS_THROUGHPUT_MB: 'Throughput (MB)',
    AWS_EBS_TYPE: 'EBS volume type',
    AWS_EBS_VOLUME: 'EBS volume per server',
    AWS_EFS: 'EFS',
    AWS_NETWORK_COST_TITLE: 'AWS network cost',
    AWS_NETWORK_DATA_TRANSFER_PER_MONTH: 'Data Transfer per month (GB)',
    AWS_NETWORK_DATA_TRANSFER: 'Data Transfer (GB)',
    AWS_NETWORK_SIZE_WITH_UNIT: 'Size (Mbits)',
    AWS_NETWORK_TOTAL: 'Total AWS network cost',
    AWS_RDS_GP: 'RDS - General Purpose',
    AWS_RDS_GP_AURORA: 'RDS - General Purpose-Aurora',
    AWS_RDS_PROVISIONED: 'RDS - Provisioned IOPS',
    AWS_S3_GLACIER: 'S3Glacier',
    AWS_S3_IA: 'S3 IA',
    AWS_S3_IA_BILLABLE_SIZE: 'Billable size (GB)',
    AWS_S3_IA_LIFECYCLE_COST: 'Lifecycle cost',
    AWS_S3_IA_PUT_COST: 'PUT requests cost',
    AWS_S3_IA_LIST_COST: 'LIST requests cost',
    AWS_S3_IA_GET_COST: 'GET requests cost',
    AWS_S3_IA_RETRIEVE_COST: 'Retrieve requests cost',
    AWS_S3_IA_SHORT_TERM_STORAGE: 'Storage used less than 30 days (GB)',
    AWS_S3_IA_SHORT_TERM_COST: 'Short term storage cost',
    AWS_S3_STANDARD: 'S3Standard',
    AWS_STORAGE_COST_TITLE: 'AWS storage cost',
    AWS_STORAGE_EBS_TITLE: 'Elastic Block Storage (EBS)',
    AWS_STORAGE_EFS_TITLE: 'Elastic File System (EFS)',
    AWS_STORAGE_IOPS: 'IOPS',
    AWS_STORAGE_OBJECT_TITLE: 'Object storage (S3)',
    AWS_STORAGE_PHYSICAL_SIZE: 'Physical server size (GB)',
    AWS_STORAGE_RAW_SIZE: 'Raw size (GB)',
    AWS_STORAGE_RDS_TITLE: 'Database storage (RDS)',
    AWS_STORAGE_SHARED_SIZE: 'Shared storage size (GB)',
    AWS_STORAGE_SIZE: 'Storage size (GB)',
    AWS_STORAGE_TOTAL: 'Total AWS storage cost',
    AWS_STORAGE_TOTAL_IOPS: 'Total/Max IOPS',
    AWS_STORAGE_TOTAL_SIZE: 'Total size (GB)',
    AWS_STORAGE_USABLE_SIZE: 'Usable size (GB)',
    AWS_STORAGE_VIRTUAL_SIZE: 'Virtual server size (GB)',
    ANNUAL_TOTAL_COST: 'Annual total cost',
    ERROR_LOADING_STORAGE: 'Failed to load TCO storage and network assessments',
    VOLUME_TYPE: 'Volume type',
};

const tcoAssumptionsConstants = {
    ALERT_MSG_RELOCATE: 'Please note that {0} does not support \'Relocate\'.',
    ALERT_MSG_INSTANCE_TYPE: 'VMWARE Instance type \'{0}\' is not supported in region {1}.',
    ALERT_MSG_FROM_CHINA: 'You are switching from a region based in China to a global region. '
        + 'The assumptions will be reset to default values, in USD, once you press \'Save and calculate\'.',
    ALERT_MSG_TO_CHINA: 'You are switching from global to a region based in China. '
        + 'The assumptions will be reset to default values, in CNY, once you press \'Save and calculate\'.',
    APPLY: 'Apply',
    CANCEL: 'Cancel',
    CURRENT_ASSUMPTIONS: 'Current assumption: ',
    DATE_MODIFIED: 'Date modified',
    DEFAULT_ASSUMPTION_SET_NAME: 'default set',
    INVALID_ASSUMPTION_NAME: 'Minimum length of 5. Maximum length of 100.',
    INVALID_ASSUMPTION_INPUT: 'Please check the configuration inputs',
    INVALID_ASSUMPTION_TYPE: 'Configuration type error',
    INVALID_DURATION_INPUT: 'Duration should be less than or equal to the refreshment period',
    INVALID_EBS_TYPES: 'Please select at least 1 EBS volume type in \'Assumptions > AWS storage > EBS volume types\'.',
    INVALID_EBS_TYPES_MSG: 'Please select at least 1 EBS volume type.',
    INVALID_MIGRATION_DURATION: 'Migration project duration should be less than TCO analysis duration.',
    INVALID_MIGRATION_PLAN_DISTRIBUTION: 'Migration distribution should sum to 100%.',
    INVALID_MIGRATION_STRATEGY: 'Migration strategy input values should be a valid integer.',
    INVALID_TCO_DURATION: 'TCO analysis duration should be less than refreshment period of infrastructure.',
    INVALID_USER_INFO: 'Unable to fetch user information',
    LOAD_AND_APPLY: 'Load and Apply',
    LOAD_ASSUMPTION_ERROR: 'Load assumption error',
    LOAD_ASSUMPTION_TITLE: 'Load assumptions set',
    MODIFY_ASSUMPTIONS: 'Modify assumptions',
    MODIFY_ASSUMPTIONS_DESCR_1: 'Please apply any changes before closing this modal or they will be lost!',
    MODIFY_ASSUMPTIONS_DESCR_2: 'You can save and load your assumptions. Saved assumptions are accessible across all your portfolios.',
    OVERRIDE_ASSUMPTION_TITLE: 'Override assumptions set',
    RELEVANT_ASSUMPTIONS: 'Only show assumptions relevant to the current page',
    RESTORE_DEFAULTS_ALERT: 'Default assumptions have been restored.',
    RESTORE_DEFAULTS_ACTION_1: 'To undo, click ',
    RESTORE_DEFAULTS_ACTION_2: 'To proceed, click ',
    SAVE_NEW_ASSUMPTION_TITLE: 'Save assumptions set',
};

const applicationPrioritizationConstants = {
    APP_PRIORITIZATION_CALCULATE_ERROR: 'Unable to determine application prioritization. This is usually due to large number of applications.'
        + ' Please check that you have imported business applications, not processes.',
    APP_PRIORITIZATION_NETWORK_ERROR: 'The application prioritization is taking longer than usual. Please wait a few minutes and refresh the page.' + 
        ' If you keep experiencing issues, please raise a bug using the Feedback dropdown in the top bar.',
    APP_PRIORITIZATION_DESCRIPTION: 'Prioritization helps you align migrations with your customer\'s business and technical drivers, '
        + 'allowing them to realize value quickly.',
    APP_PRIORITIZATION_EDIT_BUTTON_TEXT: 'Edit prioritization',
    APP_PRIORITIZATION_EDIT_STEP_1_CONTENT: 'Attributes',
    APP_PRIORITIZATION_EDIT_STEP_1_INVALID_BOUND: 'Invalid bound: lower bound {0} must be strictly less than upper bound {1}. ',
    APP_PRIORITIZATION_EDIT_STEP_1_INVALID_SCORE: 'Invalid score {0}: score must be between 0-100',
    APP_PRIORITIZATION_EDIT_STEP_1_MAX: 'Max value ...',
    APP_PRIORITIZATION_EDIT_STEP_1_MIN: 'Min value ...',
    APP_PRIORITIZATION_EDIT_STEP_1_NO_DATA: 'You currently don\'t have any data for this attributes.',
    APP_PRIORITIZATION_EDIT_STEP_1_NO_NAN: 'Invalid bound: upper bound and lower bound must be numbers. ',
    APP_PRIORITIZATION_EDIT_STEP_1_SELECT_PLACEHOLDER: 'Select attributes',
    APP_PRIORITIZATION_EDIT_STEP_1_TITLE: 'Select and score attributes',
    APP_PRIORITIZATION_EDIT_STEP_2_LEAST_RELEVANT: 'Least relevant (0.2x)',
    APP_PRIORITIZATION_EDIT_STEP_2_LESS_RELEVANT: 'Less relevant (0.4x)',
    APP_PRIORITIZATION_EDIT_STEP_2_MORE_RELEVANT: 'More relevant (0.8x)',
    APP_PRIORITIZATION_EDIT_STEP_2_MOST_RELEVANT: 'Most relevant (1x)',
    APP_PRIORITIZATION_EDIT_STEP_2_RELEVANT: 'Relevant (0.6x)',
    APP_PRIORITIZATION_EDIT_STEP_2_TITLE: 'Rank business attributes',
    APP_PRIORITIZATION_EDIT_STEP_2_UNRANKED: 'Unranked',
    APP_PRIORITIZATION_EDIT_SUBMIT_TEXT: 'Prioritize applications',
    APP_PRIORITIZATION_GET_CRITICALITY_ERROR: 'Unable to get existing criticality.',
    APP_PRIORITIZATION_GRAPH_HIGH_PRIOR: 'High priority',
    APP_PRIORITIZATION_GRAPH_LOW_PRIOR: 'Low priority',
    APP_PRIORITIZATION_GRAPH_TITLE: 'Application rank distribution',
    APP_PRIORITIZATION_NOT_RANKED_MSG: 'All attributes must be ranked',
    APP_PRIORITIZATION_SAVE_CONFIGS_ERROR: 'Unable to save selected attributes and configurations',
    APP_PRIORITIZATION_SELECT_ATTRIBUTE_MSG: 'Select at least one attribute',
    APP_PRIORITIZATION_SCORE: 'Scores',
    APP_PRIORITIZATION_TITLE: 'Application prioritization',
    APP_PRIORITIZATION_VALUE: 'Value',
    APP_PRIORITIZATION_VALUE_RANGE: 'Ranges of values',
    APP_PRIORITIZATION_VALUE_RANGE_DESCRIPTION: '(lower bounds, upper bounds)',
};

const tcoActionPanelConstants = {
    COMPARE_ASSESSMENTS: 'Compare assessments',
    CREATE_NEW_ASSESSMENT: 'Create new assessment',
    DELETE_ASSESSMENT: 'Delete assessment',
    DELETE_FRICTION: 'delete',
    EDIT_ASSESSMENT: 'Edit assessment',
    ERROR_CREATING_ASSESSMENT: 'Failed to create assessment',
    ERROR_DELETING_ASSESSMENT: 'Failed to delete assessment',
    ERROR_DOWNLOADING_TCO_ASSESSMENT: 'Failed to download TCO assessment',
    ERROR_LOADING_ASSESSMENT_DATA: 'Failed to load assessment data',
    ERROR_OPENING_FILE_URL_CONTENT: 'Please allow pop-ups from this site to download sample and template files.',
    ERROR_OPENING_FILE_URL_HEADER: 'File download is blocked by your browser',
    ERROR_REDIRECTING: 'Failed to redirect to default assessment',
    ERROR_SAVING_ASSESSMENT: 'Failed to save assessment',
    ERROR_UPDATING_ASSESSMENT: 'Failed to update assessment',
    MODIFY_ASSUMPTIONS: 'Modify assumptions',
    OUT_OF_DATE_PRICING_HEADER: 'Your existing calculations are based on out-of-date pricing information',
    OUT_OF_DATE_PRICING_P1: 'Please click \'Calculate\' to update your assessment using the latest pricing information.',
    TCO_DESCRIPTION: 'The TCO provides estimates of your AWS and On-Premises costs.',
    TCO_DESCRIPTION_2: 'Click \'Calculate\' to generate the TCO with the default assumptions, or click \'Modify assumptions\' to set your own values.',
    TOTAL_COST_OF_OWNERSHIP: 'Total cost of ownership (TCO)',
    WARNING_AWS_DETAILS_EXCLUDED_CONTENT: 'The number of servers in the portfolio leads to a file size that exceeds the current 6MB limit',
    WARNING_AWS_DETAILS_EXCLUDED_HEADER: 'AWS Details Tab is excluded from the TCO download',
};

const tcoAssessmentModalConstants = {
    AWS_TOTAL_COST: 'AWS total cost',
    COMPARE_ASSESSMENT_MODAL_TITLE: 'Compare assessments',
    CREATE_MODAL_ASSESSMENT_NAME_FIELD_LABEL: 'Assessment name *',
    CREATE_NEW_ASSESSMENT_MODAL_TITLE: 'Create new assessment',
    DATABASE_SOFTWARE_AND_LICENSES: 'Database engine software and licenses',
    DEFAULT_ASSESSMENT_MODAL_TITLE: 'Assessment controls',
    DEFAULT_ASSESSMENT_NAME: 'Assessment 1',
    DELETE_ASSESSMENT_MODAL_TITLE: 'Delete assessment',
    DISCOUNT_ADJUSTMENT: 'Discount/Adjustment',
    EDIT_ASSESSMENT_MODAL_TITLE: 'Edit assessment',
    EDIT_ASSESSMENT_OVERRIDE_ASSUMPTIONS_MESSAGE: 'Overwrite all this assessment\'s assumptions and migration configuration values?'
        + ' Any changes you\'ve made will be lost.',
    ERROR_LOADING_COMPARE_ASSESSMENTS: 'Failed to load compare assessments',
    GENERAL_ASSUMPTIONS: 'General assumptions',
    GENERAL_STORAGE_ASSUMPTIONS: 'General storage assumptions',
    IT_LABOR_ESTIMATE: 'IT labor estimate',
    NETWORK_ESTIMATE: 'Network estimate',
    ON_PREM_TOTAL_COST: 'On-Premises total cost',
    ONLY_SHOW_DIFFERENCES: 'Only show differences',
    POWER: 'Power',
    RACK_INFRA: 'Rack infrastructure',
    SAVING_PERCENT: 'Saving percent',
    SERVER_ESTIMATE: 'Server estimate',
    SOFTWARE_AND_LICENSES: 'Software and licenses',
    STORAGE_ESTIMATE: 'Storage estimate',
    SUPPORT_ESTIMATE: 'Support estimate',
    UNSUPPORTED_MODAL_ACTION: 'Unsupported action',
    USE_ASSUMPTION_VALUE_FROM_ASSESSMENT: 'Use assumption values from an assessment',
    USE_DEFAULT_ASSUMPTION_VALUE: 'Use default assumption value',
};

const tcoSavingsSummaryPageConstants = {
    DOWNLOAD: 'Download',
    ESTIMATED_SAVINGS_ON_AWS: 'Estimated savings on AWS',
    MONTHLY_AVG: 'Monthly average',
    NEGATIVE_SAVING_AVG_CPU: 'Industry standard average CPU utilization is {0}%. Average CPU utilization for this portfolio is {1}%. '
        + 'Please validate average CPU utilization.',
    NEGATIVE_SAVING_AVG_RAM: 'Industry standard average RAM utilization is {0}%. Average RAM utilization for this portfolio is {1}%. '
        + 'Please validate average RAM utilization.',
    NEGATIVE_SAVING_HEADER: 'Your total estimated AWS cost is greater than on-premises cost. Please check the following field(s):',
    NEGATIVE_SAVING_PEAK_CPU: 'Industry standard peak CPU utilization is {0}%. Peak CPU utilization for this portfolio is {1}%.'
        + 'Please validate peak CPU utilization.',
    NEGATIVE_SAVING_PEAK_RAM: 'Industry standard peak RAM utilization is {0}%. Peak RAM utilization for this portfolio is {1}%. '
        + 'Please validate peak RAM utilization.',
    NEGATIVE_SAVING_SERVER_UPTIME: 'Industry standard non-production server uptime is {0}%. ' 
        + 'Industry standard production server uptime is {1}%. Average server uptime for this portfolio is {2}%. Please validate the server uptime.',
    REGION: 'Region',
    TOTAL_COST_OF_OWNERSHIP_FOR: 'Total cost of ownership for',
    YEARS_IN: 'Years in',
    YOUR_TOTAL_ESTIMATED_AWS_COST: 'Your total estimated AWS cost',
    YOUR_TOTAL_ESTIMATED_ON_PREM_COST: 'Your total estimated On-Premises cost',
};

const tcoSummaryPageConstants = {
    AWS: 'AWS',
    AWS_VS_ON_PREM_CASH_FLOW: 'AWS vs. On-Premises cash flow',
    AWS_VS_ON_PREM_COST_BREAKDOWN: 'AWS vs. On-Premises cost breakdown',
    AWS_VS_ON_PREM_TOTAL: 'AWS vs. On-Premises cost total',
    CASH_FLOW_SUMMARY: 'Cash flow summary',
    ERROR_LOADING_SUMMARY: 'Failed to load TCO summary',
    GAIN_LOSS: 'Gain / Loss',
    ON_PREMISES: 'On-Premises',
    RESIDUAL_AND_UNUSED_VALUE: 'Residual and unused value',
    SUMMARY_REPORT: 'Summary report',
    YEAR: 'Year',
};

const tcoCommonConstants = {
    APPLICATION_ID: 'Application ID',
    AVG_CPU_PER_VM: 'Avg. CPU per VM',
    AVG_RAM_PER_VM: 'Avg. RAM per VM (GB)',
    AVG_VM_PER_HOST: 'Avg. VM per host',
    AWS_COST: 'AWS cost',
    CASH_FLOW_NAME: 'Cash flow',
    COST_PER_UNIT: 'Cost of host per unit',
    DATABASE_ID: 'Database ID',
    DETAILS: 'Details',
    EMPTY_VALUE_PLACEHOLDER: '-',
    EXCLUSION_TITLE: 'Summary of resources excluded from analysis:',
    FACILITIES_DESCRIPTION: 'Facilities to operate servers',
    FACILITIES: 'Facilities',
    HOST_DESCRIPTION: ' physical server(s)',
    HOST_NAME: 'Host name',
    HOST_REQUIRED: 'Hosts required',
    IT_LABOR_ADJUSTMENT: 'IT Labor adjustment',
    MAINTENANCE: 'Maintenance',
    NETWORK_ADJUSTMENT: 'Network adjustment',
    ON_PREMISES_COST: 'On-Premises cost',
    PHYSICAL_SERVERS_TYPE: 'Physical servers',
    RACK_INFRA_DESCRIPTION: 'Rack and infrastructure to operate servers',
    RACK_INFRA_TYPE: 'Rack infrastructure',
    RESIDUAL_VALUE_DESCRIPTION: 'Residual value after TCO duration',
    RESIDUAL_VALUE_TYPE: 'Residual value',
    SAVINGS: 'Savings',
    SERVER_ID: 'Server ID',
    SERVER_MAINTENANCE_CONTRACT_DESCRIPTION: 'Server maintenance contract for physical servers and hosts',
    SERVER_MAINTENANCE_CONTRACT_TYPE: 'Server maintenance contract',
    SOFTWARE_AND_LICENSE_DESCRIPTION: 'Software and license cost to operate servers',
    SOFTWARE_AND_LICENSE_TYPE: 'Software and licenses',
    STORAGE_ADJUSTMENT: 'Storage adjustment',
    STORAGE_COST: 'Storage cost',
    SUPPORT_ADJUSTMENT: 'Support adjustment',
    TCO_ADJUSTED_TOTAL: 'Adjusted total',
    TCO_PAGE_SUMMARY_COST: 'Cost',
    TCO_PAGE_SUMMARY_DESCRIPTION: 'Description',
    TCO_PAGE_SUMMARY_TYPE: 'Type',
    TCO_TOTAL_COST: 'Total cost',
    VIRTUAL_SERVERS_TYPE: 'Host servers',
    VOLUME_COST: 'Volume cost',
    VOLUME_GB: 'Volume (GB)',
    UNIT: 'Unit',
    STORAGE_SERVER: 'Server storage',
    STORAGE_DATABASE: 'Database storage',
    STORAGE_SHARED: 'Shared storage',
    WITH_UNEXPECTED_ERROR: 'with unexpected error',
};

const tcoOnPremServerCostPageConstants = {
    ERROR_LOADING_ONPREM: 'Failed to load TCO On-Premises',
    ON_PREM_ADD_HOST_TYPE: 'Add row',
    ON_PREM_CASH_FLOW_NETWORK_BANDWIDTH: 'Bandwidth cost',
    ON_PREM_CASH_FLOW_NETWORK_COLO_CHARGE: 'Colocation recurring charges',
    ON_PREM_CASH_FLOW_NETWORK_COST: 'Network cost',
    ON_PREM_CASH_FLOW_NETWORK_MAINTENANCE: 'Network maintenance',
    ON_PREM_CASH_FLOW_NETWORK_REDUNDANCY: 'On-Premises redundancy',
    ON_PREM_CASH_FLOW_SERVERS: 'Servers (physical and hosts)',
    ON_PREM_CASH_FLOW_SERVERS_MAINTENANCE: 'Server maintenance contract',
    ON_PREM_CASH_FLOW_STORAGE_BACKUP_COST: 'Backup cost',
    ON_PREM_CASH_FLOW_STORAGE_BACKUP_SIZE: 'Backup size (GB)',
    ON_PREM_CASH_FLOW_STORAGE_FACILITIES: 'Facilities (rack operation cost)',
    ON_PREM_CASH_FLOW_STORAGE_NAS_COST: 'NAS cost',
    ON_PREM_CASH_FLOW_STORAGE_NAS_SIZE: 'NAS size (GB)',
    ON_PREM_CASH_FLOW_STORAGE_OBJECT_COST: 'Object cost',
    ON_PREM_CASH_FLOW_STORAGE_OBJECT_SIZE: 'Object size (GB)',
    ON_PREM_CASH_FLOW_STORAGE_PHYSICAL_DATABASE_COST: 'Physical database storage cost',
    ON_PREM_CASH_FLOW_STORAGE_PHYSICAL_DATABASE_SIZE: 'Physical database storage size (GB)',
    ON_PREM_CASH_FLOW_STORAGE_PHYSICAL_SERVER_COST: 'Physical server storage cost',
    ON_PREM_CASH_FLOW_STORAGE_PHYSICAL_SERVER_SIZE: 'Physical server storage size (GB)',
    ON_PREM_CASH_FLOW_STORAGE_RACKS_COST: 'Rack purchase cost',
    ON_PREM_CASH_FLOW_STORAGE_RACKS_REQUIRED: 'Racks required',
    ON_PREM_CASH_FLOW_STORAGE_SAN_COST: 'SAN cost',
    ON_PREM_CASH_FLOW_STORAGE_SAN_SIZE: 'SAN size (GB)',
    ON_PREM_CASH_FLOW_STORAGE_TAP_CARTRDGES: 'Number of tape cartridges required',
    ON_PREM_CASH_FLOW_STORAGE_TAPE_REQUIRED: 'Number of tape drivers required',
    ON_PREM_CASH_FLOW_STORAGE_VIRTUAL_DATABASE_COST: 'Virtual database storage cost',
    ON_PREM_CASH_FLOW_STORAGE_VIRTUAL_DATABASE_SIZE: 'Virtual database storage size (GB)',
    ON_PREM_CASH_FLOW_STORAGE_VIRTUAL_SERVER_COST: 'Virtual server storage cost',
    ON_PREM_CASH_FLOW_STORAGE_VIRTUAL_SERVER_SIZE: 'Virtual server storage size (GB)',
    ON_PREM_CONFIGURE_HOST_TYPES: 'Configure host types',
    ON_PREM_CPU_SUBSCRIPTION_RATIO: 'CPU subscription ratio',
    ON_PREM_DATABASE_TITLE: 'On-Premises database cost',
    ON_PREM_FACILITY_COLOCATION: 'Colocation',
    ON_PREM_FACILITY_ON_PREMISES: 'On-Premises',
    ON_PREM_FACILITY_RACK_OPERATION: 'Rack operation',
    ON_PREM_FACILITY_TYPE: 'Facility type',
    ON_PREM_HYPERTHREAD: 'Threads count',
    ON_PREM_LICENSE_MS_ASSURANCE: 'Microsoft Hyper-V Software Assurance (yearly)',
    ON_PREM_LICENSE_MS_LICENSE: 'Microsoft Hyper-V licenses (2-core pack, one-time)',
    ON_PREM_LICENSE_RHEL_PHYSICAL: 'RHEL license for physical servers (per 2 CPUs, yearly)',
    ON_PREM_LICENSE_RHEL_VIRTUAL: 'RHEL license for virtual servers (per 2 host CPUs, yearly)',
    ON_PREM_LICENSE_SUSE_PHYSICAL: 'SUSE license for physical servers (per 2 CPUs, yearly)',
    ON_PREM_LICENSE_SUSE_VIRTUAL: 'SUSE license for virtual servers (per 2 host CPUs, yearly)',
    ON_PREM_LICENSE_VMWARE_LICENSE: 'VMware vSphere license (per CPU, one-time)',
    ON_PREM_LICENSE_VMWARE_SUPPORT: 'VMware vSphere support and subscription (yearly)',
    ON_PREM_LICENSE_WINDOWS_ASSURANCE: 'Windows Software Assurance (yearly)',
    ON_PREM_LICENSE_WINDOWS_GUEST: 'Windows guest OS license (2-core pack, one-time)',
    ON_PREM_LICENSE_WINDOWS_GUEST_ASSURANCE: 'Windows guest OS Software Assurance (yearly)',
    ON_PREM_LICENSE_WINDOWS_PHYSICAL: 'Windows license for physical servers (2-core pack, one-time)',
    ON_PREM_NETWORK_CASH_FLOW: 'Network cash flow',
    ON_PREM_NETWORK_COST: 'On-Premises network cost',
    ON_PREM_NETWORK_HARDWARE_SOFTWARE: 'Network hardware and software',
    ON_PREM_NETWORK_TOTAL_COST: 'Total On-Premises network cost',
    ON_PREM_OVERHEAD: 'Overhead',
    ON_PREM_OVERHEAD_COST: 'Overhead costs',
    ON_PREM_PHYSICAL_CORE: 'Cores',
    ON_PREM_PHYSICAL_POWER: 'Power (KW)',
    ON_PREM_PHYSICAL_PROCEESOR: 'Processors',
    ON_PREM_PHYSICAL_RAM: 'RAM (GB)',
    ON_PREM_PHYSICAL_SERVER_COST: 'Server cost',
    ON_PREM_PHYSICAL_SPACE: 'Space (Unit)',
    ON_PREM_RACK: 'Racks',
    ON_PREM_RACK_1_TIME: 'Rack and stack 1-time deployment, per server',
    ON_PREM_RACK_PDU: 'PDUs, dual 280V per rack (2 for HA)',
    ON_PREM_RACK_PROVISION: 'Provision for spare server',
    ON_PREM_RACK_TOR: 'ToR 24x10GbE 48 port support',
    ON_PREM_RAM_SUBSCRIPTION_RATIO: 'Ram subscription ratio',
    ON_PREM_SERVER_TITLE: 'On-Premises server cost',
    ON_PREM_STORAGE_BACK_UP_TITLE: 'Storage backup costs',
    ON_PREM_STORAGE_BACK_UP_TOTAL_SIZE: 'Total backup size (GB)',
    ON_PREM_STORAGE_CASH_FLOW: 'Storage cash flow',
    ON_PREM_STORAGE_TOTAL_COST: 'Total On-Premises storage cost',
    ON_PREM_TAPES_CARTRIDGES_REQUIRED: 'Tape cartridges required',
    ON_PREM_TAPES_REQUIRED: 'Tapes required',
};

const tcoOnPremisesStorageAndNetworkConstants = {
    NO_BACKUP_WARNING: 'Please recalculate the portfolio to view estimated On-Premises server storage cost.',
    ON_PREM_STORAGE_COST_TITLE: 'On-Premises storage cost',
    ON_PREM_STORAGE_TOTAL: 'Total storage (GB)',
    ON_PREM_STORAGE_USAGE_TOTAL: 'Total usable storage (GB)',
    ON_PREM_PHYSICAL_SERVER_STORAGE: 'Physical server storage',
    ON_PREM_VIRTUAL_SERVER_STORAGE: 'Virtual server storage',
    ON_PREM_PHYSICAL_DATABASE_STORAGE: 'Physical database storage',
    ON_PREM_VIRTUAL_DATABASE_STORAGE: 'Virtual database storage',
    ON_PREM_STORAGE_SAN: 'SAN',
    ON_PREM_STORAGE_NAS: 'NAS',
    ON_PREM_STORAGE_OBJECT: 'Object',
};

const olaAssessmentConstants = {
    ERROR_LOADING_OLA: 'Failed to load TCO SQL Server optimizations',
    OLA_SQL_EDITION_DETAILS: 'TDE and Always On Availability groups tend to be the biggest SQL EE feature drivers, '
        + 'and we have alternatives for both of those listed above. '
        + 'SQL is the largest cost driver if we can reduce the mix of Enterprise, '
        + 'not only for your cloud bill but also putting licenses back on the shelf to avoid future true ups and reduce Software Assurance/Maintenance spend.',
    OLA_SQL_EDITION_INSTRUCTION: ' Please run this script to determine if using features of SQL EE vs SQL Standard',
    OLA_SQL_EDITION_STEP_ONE_HERE: ' here.',
    OLA_SQL_EDITION_STEP_ONE_OR: ' or ',
    OLA_SQL_EDITION_STEP_ONE_RUN: 'Run',
    OLA_SQL_EDITION_STEP_ONE_THIS_SCRIPT: ' this script ',
    OLA_SQL_EDITION_STEP_TWO: 'Things to consider: Are you using Always-On Availability Groups? '
        + ' In this case you can use Basic Availability groups in Standard Edition as well, but have your teams research the differences.',
    OLA_SQL_EDITION_STEP_THREE: 'Things to consider: Standard supports up to 24 cores, '
        + 'and 128GB memory per instance of SQL Database engine, plenty for most database needs.',
    OLA_SQL_EDITION_STEP_FOUR: 'Things to consider: If you are using SQL EE for Transparent Data Encryption, '
        + 'there are other methods in AWS to accomplish at rest encryption which allow for this feature.',
    OLA_SQL_NO_COST_DIFF: 'It looks like you are not getting any license savings. '
        + 'Please consult an AWS Microsoft SA for details on leveraging EC2 Dedicated Hosts.',
    OLA_SQL_SERVER_TABLE_AWS_LICENSE: 'AWS optimized minimum license requirements',
    OLA_SQL_SERVER_TABLE_AWS_LICENSE_CONSOLIDATED: 'AWS optimized minimum license requirements with consolidation',
    OLA_SQL_SERVER_TABLE_COST_DIFF: 'License cost savings',
    OLA_SQL_SERVER_TABLE_COST_DIFF_CONSOLIDATED: 'License cost savings with consolidation',
    OLA_SQL_SERVER_TABLE_COUNT_DIFF: 'Optimized vs On-Premises core requirement difference',
    OLA_SQL_SERVER_TABLE_COUNT_DIFF_CONSOLIDATED: 'Optimized vs On-Premises core requirement difference with consolidation',
    OLA_SQL_SERVER_TABLE_EC2_INSTANCE: 'EC2 instance type',
    OLA_SQL_SERVER_TABLE_EC2_INSTANCE_VCPU: 'EC2 Instance vCPUs',
    OLA_SQL_SERVER_TABLE_EDITION: 'SQL Server edition',
    OLA_SQL_SERVER_TABLE_IS_CONSOLIDATED: 'Consolidation',
    OLA_SQL_SERVER_TABLE_IS_PHYSICAL: 'Physical/Virtual',
    OLA_SQL_SERVER_TABLE_IS_REPLICA: 'Replica server',
    OLA_SQL_SERVER_TABLE_ON_PREM_CORES: 'On-Premises cores per CPU',
    OLA_SQL_SERVER_TABLE_ON_PREM_CPU: 'On-Premises CPUs',
    OLA_SQL_SERVER_TABLE_ON_PREM_LICENSE: 'On-Premises minimum license requirements',
    OLA_SQL_SERVER_TABLE_ON_PREM_THREAD: 'On-Premises threads per core',
    OLA_SQL_SERVER_TABLE_ON_PREM_USAGE: 'On-Premises CPU peak utilization',
    OLA_SQL_SERVER_TABLE_PHYSICAL: 'Physical',
    OLA_SQL_SERVER_TABLE_VIRTUAL: 'Virtual',
    OLA_SUMMARY_TABLE_EDITION: 'Edition',
    OLA_SUMMARY_TABLE_EDITION_DEVELOPER: 'Developer',
    OLA_SUMMARY_TABLE_EDITION_ENTERPRISE: 'Enterprise',
    OLA_SUMMARY_TABLE_EDITION_STANDARD: 'Standard',
    OLA_SUMMARY_TABLE_ONPREM: 'On-Premises count',
    OLA_SUMMARY_TABLE_OPTIMIZED: 'Optimized count',
    OLA_SUMMARY_TABLE_REDUCTION: 'Reduction',
    OLA_SUMMARY_TABLE_SAVING: 'Savings',
    OLA_TAB_SQL_EDITION_LABEL: 'SQL Edition optimization',
    OLA_TAB_SQL_SERVER_LABEL: 'SQL Server optimization',
    OLA_TAB_SQL_SERVER_FILENAME: 'SQL Server optimization details',
    OLA_TITLE: 'SQL Server licensing optimization',
    OLA_TITLE_DESCRIPTION: 'The Dedicated Host licensing tool is available at this ',
    OLA_TITLE_DESCRIPTION_SOURCE: 'external source.',
    TOTAL_REDUCTION: 'Total Reduction',
    TOTAL_SAVINGS_HEADER: 'Total Savings',
};

const tcoFooterConstants = {
    DEFAULT_LEGAL_MESSAGE: 'The Total cost of ownership Calculator provides an estimate of usage charges for On-Premises/Colocation compared to equivalent AWS'
        + ' services based on the information you provide. AWS monthly charges will be based on your actual usage of AWS services, and may vary from the'
        + ' estimates the Calculator has provided.',
    DOES_NOT_INCLUDE_MIGRATION_COST: 'Does not include the migration cost.',
    LEGAL_MESSAGE_DB_LICENSE: 'License cost may vary depending on database vendor rates.',
    LEGAL_MESSAGE_WITH_RDS: 'The Total cost of ownership Calculator provides an estimate of usage charges for On-Premises/Colocation compared to equivalent AWS'
        + ' services, including \'Amazon Relational Database Services (Amazon RDS)\', based on the information you provide. AWS monthly charges, and any'
        + ' \'Amazon RDS\' charges, will be based on your actual usage, discounts, and effective bill rates at the time of usage and may vary from the'
        + ' estimates the Calculator has provided.',
    LEGAL_MESSAGE_WITH_RDS_AND_RELOCATE: 'The Total cost of ownership Calculator provides an estimate of usage charges for On-Premises/Colocation compared to'
        + ' equivalent AWS services, including \'VMware Cloud on AWS\' and \'Amazon Relational Database Services (Amazon RDS)\', based on the information you'
        + ' provide. AWS monthly charges, and any \'VMware Cloud on AWS\' and \'Amazon RDS\' charges, will be based on your actual usage, discounts, and'
        + ' effective bill rates at the time of usage and may vary from the estimates the Calculator has provided.',
    LEGAL_MESSAGE_WITH_RELOCATE: 'The Total cost of ownership Calculator provides an estimate of usage charges for On-Premises/Colocation compared to'
        + ' equivalent AWS services, including \'VMware Cloud on AWS\', based on the information you provide. AWS monthly charges, and any'
        + ' \'VMware Cloud on AWS\' charges, will be based on your actual usage, discounts, and effective bill rates at the time of usage and'
        + ' may vary from the estimates the Calculator has provided.',
};

const ec2RecommendationConstants = {
    AVERAGE_UTILIZATION: 'Average utilization',
    AWS_SERVER_RECOMMENDATIONS: 'AWS server recommendations',
    COUNT: 'Count',
    DEDICATED_HOSTS: 'Dedicated Hosts',
    DETAILS: 'Details',
    EC2_INSTANCE_TYPE_DETAILS: 'EC2 instance type details',
    EC2_INSTANCES: 'EC2 instance types',
    ERROR_CALCULATING_EC2_RECOMMENDATION: 'We ran into an error running the EC2 recommendations.'
        + ' We have raised an alert and are looking into it. Please try again later.',
    ERROR_LOADING_EC2_ASSESSMENT: 'Failed to load AWS EC2 assessment',
    ERROR_LOADING_EC2_INSTANCE_TYPES: 'Failed to load EC2 instance types',
    ERROR_LOADING_RULES: 'Failed to load assessment rules',
    ERROR_OVERRIDING_EC2_RECOMMENDATION: 'Failed to override EC2 recommendation',
    INSTANCE_TYPE: 'Instance type',
    INSTANCE_TYPE_ERROR: ' Please check tenancy and operating system of the servers.',
    INVALID_INPUT: 'Invalid input',
    ITEM_S: 'item(s)',
    LIST_OF_INSTANCE_TYPE: 'List of instance type',
    ON_PREM_CAPACITY: 'On-Premises capacity',
    OVERRIDE_EC2_RECOMMENDATION_HEADER: 'Override EC2 recommendation',
    PEAK_UTILIZATION: 'Peak utilization',
    PREINSTALLED_SOFTWARE: 'Pre-installed software',
    RECOMMENDATION_TYPE: 'Recommendation type',
    RECOMMENDED_PAYMENT_OPTION: 'Recommended payment option',
    UNDO_MANUAL_OVERRIDE: 'Undo manual override',
    UPDATE_SUCCESSFUL: 'Update successful',
    V_CPU: 'vCPUs',
    VALIDATION_FAILED: 'Validation failed',
    VMWARE_CLOUD: 'VMware Cloud on AWS',
    VMWARE_CLOUD_SUBSCRIPTION: ' Year subscription',
    MEMORY: 'Memory (GiB)',
    OPERATING_SYSTEM: 'Operating system',
    OVERRIDDEN: 'Overridden',
    TENANCY: 'Tenancy',
};

const ec2RecommendationDedicatedHostConstants = {
    AWS_DEDICATED_HOST_RECOMMENDATIONS: 'AWS Dedicated Host recommendations',
    INSTANCE_FAMILY: 'Instance family',
    LARGE: 'large',
    NANO: 'nano',
    MICRO: 'micro',
    SMALL: 'small',
    MEDIUM: 'medium',
    METAL: '.metal',
    PHYSICAL_CORES: 'Physical cores',
    UNALLOCATD_VCORES: 'Unallocated vCPUs',
    X10_LARGE: '10xlarge',
    X12_LARGE: '12xlarge',
    X16_LARGE: '16xlarge',
    X18_LARGE: '18xlarge',
    X24_LARGE: '24xlarge',
    X2_LARGE: '2xlarge',
    X32_LARGE: '32xlarge',
    X3_LARGE: '3xlarge',
    X4_LARGE: '4xlarge',
    X6_LARGE: '6xlarge',
    X8_LARGE: '8xlarge',
    X9_LARGE: '9xlarge',
    X_LARGE: 'xlarge',
};

const ec2RecommendationVMWareConstants = {
    CLUSTER_NAME: 'Cluster name',
    VMWARE_CLOUD_RECOMMENDATIONS_DETAIL: 'VMware Cloud on AWS recommendation details',
};

const ec2CostConstants = {
    AGGREGATED_MONTHLY_COST: 'Aggregated monthly cost',
    ANNUAL_COST: 'Annual cost',
    CPU: 'CPU',
    DEDICATED_HOST_DETAILS: 'Dedicated Host details',
    DEDICATED_HOST_IN_PREVIEW_HEADER: 'Dedicated Host implementation in MPA is a preview feature',
    DEDICATED_HOST_IN_PREVIEW: 'Dedicated Host recommendations logic uses a heuristic approach and therefore works best for a large number' +
        ' of servers that require more Dedicated Hosts.',
    DEDICATED_HOST_OS_COST: 'Software and licenses',
    DEDICATED_HOST_RESIDUAL_VALUE_DESCRIPTION: 'Value after TCO duration for Dedicated Hosts',
    DEDICATED_HOST_RESIDUAL_VALUE_TYPE: 'Amazon EC2 Dedicated Hosts residual value',
    SOFTWARE_LICENSE_DESCRIPTION: 'OS and database costs paid to vendors',
    THIRD_PARTY_SOFTWARE_LICENSE_TYPE: 'Software and licenses - 3rd party',
    DEDICATED_HOST_TYPE: 'Amazon EC2 Dedicated Hosts',
    DEDICATED_HOST_UNUSED_VALUE_DESCRIPTION: 'Unused capacity on EC2 Dedicated Host(s)',
    DEDICATED_HOST_UNUSED_VALUE_TYPE: 'Amazon EC2 Dedicated Hosts unused value',
    DETERMINING_FACTOR: 'Determining factor',
    DH_OS_COST_WINDOWS_FOR_DH: 'Windows license for Dedicated Hosts (per 2-core pack, one-time)',
    DH_OS_COST_WINDOWS_ASSURANCE: 'Windows Software Assurance (yearly)',
    DH_OS_COST_ENTERPRISE_SQL_FOR_DH: 'Enterprise SQL Server license for Dedicated Hosts (per 2-core pack, one-time)',
    DH_OS_COST_ENTERPRISE_SQL_SUPPORT: 'Enterprise SQL Server support cost (per 2-core pack yearly)',
    DH_OS_COST_STANDARD_SQL_FOR_DH: 'Standard SQL Server license for Dedicated Hosts (per 2-core pack, one-time)',
    DH_OS_COST_STANDARD_SQL_SUPPORT: 'Standard SQL Server support cost (per 2-core pack yearly)',
    OS_COST_TYPE_THIRD_PARTY: '3rd party',
    OS_COST_ENTERPRISE_ORACLE: 'Enterprise Oracle license (1 per 2 vCPUs, one-time)',
    OS_COST_ENTERPRISE_ORACLE_SUPPORT: 'Enterprise Oracle support cost (yearly)',
    OS_COST_STANDARD_ORACLE: 'Standard Oracle license (1 per 4 vCPUs, one-time)',
    OS_COST_STANDARD_ORACLE_SUPPORT: 'Standard Oracle license support cost (yearly)',
    EC2_CASH_FLOWS: 'EC2 cash flows',
    EC2_COST_TITLE: 'AWS compute cost',
    EC2_INSTANCE_TYPES: 'EC2 instance types',
    EC2_PAYMENT_OPTION_DETAIL: 'EC2 payment option details',
    EC2_PAYMENT_OPTION_SUMMARY: 'EC2 payment option summary',
    EC2_PRICING_DETAIL: 'EC2 pricing details',
    EC2_RESIDUAL_VALUE_TYPE: 'Amazon EC2 instance residual value',
    EC2_RI_VOLUME_DISCOUNT: 'EC2 RI Volume Discount',
    EC2_SHARED_AND_DEDICATED_INSTANCES_TYPE: 'Amazon EC2 Shared and Dedicated Instances',
    EC2_TYPE: 'EC2 instance type',
    ERROR_LOADING_EC2: 'Failed to load TCO EC2 assessment',
    HOST_COST: 'Host cost',
    HOST_COUNT: 'Host count',
    HOST_S: 'host(s)',
    HOST_TYPE: 'Host type',
    INSTANCE_S: 'instance(s)',
    MAXIMUM_HOSTS_REACHED: 'Maximum hosts reached',
    MINIMUM_HOSTS_REQUIRED: 'Minimum hosts required',
    NO_HOST_OS_COST_P1_1: 'For an estimation of Windows BYOL licenses in Dedicated Host, you can turn ',
    NO_HOST_OS_COST_P1_2: 'Estimate Windows licenses on Dedicated Host',
    NO_HOST_OS_COST_P1_3: 'Assumptions > Software and licenses.',
    NO_HOST_OS_COST_P2_1: 'For an estimation of SQL Server BYOL licenses in Dedicated Host, you can turn ',
    NO_HOST_OS_COST_P2_2: 'Include database license assessment in TCO',
    NO_HOST_OS_COST_P2_3: 'Assumptions > Database licenses.',
    NO_HOST_OS_COST_P3: 'See more details in the',
    ON_DEMAND: 'On Demand',
    PAYMENT_TYPE: 'Payment type',
    RAM: 'RAM',
    RESIDUAL: 'Residual',
    RESIDUAL_VALUE_DESCRIPTION: 'Value after TCO duration',
    RI_TIER_DISCOUNT: 'RI Volume Discount',
    RI_VOLUME_DISCOUNT: 'Reserved Instance Volume Discount',
    SELECT_A_PAYMENT_TYPE: 'Select a payment type:',
    STORAGE_CAPITALIZED: 'Storage',
    TOTAL_MONTHLY_COST: 'Total monthly cost',
    TOTAL_RESIDUAL: 'Total Residual',
    TOTAL_UPFRONT_COST: 'Total upfront cost',
    TYPE: 'Type',
    UNUSED_CAPACITY: 'Unused capacity',
    UNUSED_VALUE: 'Unused value',
    UNUSED_VCPUS: 'Unused vCPUs',
    V_CPUS: 'vCPUs',
    VMWARE_CLOUD_CASH_FLOWS: 'VMware Cloud cash flows',
    VMWARE_CLOUD_CLUSTERS: 'VMware Cloud clusters',
    VMWARE_DESCRIPTION: 'VMware host(s)',
    VMWARE_RESIDUAL_VALUE_DSECRIPTION: 'Value after TCO duration',
    VMWARE_RESIDUAL_VALUE_TYPE: 'VMware Cloud on AWS residual value',
    VMWARE_TYPE: 'VMware Cloud on AWS',
    VMWARE_UNUSED_VALUE_DESCRIPTION: 'Unused capacity on VMware host(s)',
    VMWARE_UNUSED_VALUE_TYPE: 'VMware Cloud on AWS unused value',
    VOLUME_DISCOUNT_DESCRIPTION: 'Standard Reserved Instance Volume Discount',
    VOLUME_DISCOUNT_TYPE: 'Amazon EC2 RI Volume Discount',
    YEAR_SUBSCRIPTION: 'Year subscription',
};

const paymentOptionsCommonConstants = {
    ALL: 'All',
    PARTIAL: 'Partial',
    STANDARD: 'Standard',
    UPFRONT: 'Upfront',
    YR: 'yr',
};

const itLaborSupportCostConstants = {
    AWS_DB_ADMIN_COST: 'AWS database admin cost',
    AWS_DH_ADMIN_COST: 'AWS Dedicated Host admin cost',
    AWS_EC2_ADMIN_COST: 'AWS EC2 admin cost',
    AWS_STORAGE_ADMIN_COST: 'AWS storage admin cost',
    AWS_SUPPORT: 'AWS support',
    AWS_SUPPORT_COST: 'AWS support cost',
    IT_LABOR: 'IT labor',
    IT_LABOR_SUPPORT_TITLE: 'AWS IT labor and support cost',
    PARTNER_PRICE: 'Partner cost',
    SUPPORT_PLAN_COST: 'AWS Support plan cost',
};

const tcoOnPremiseITLaborConstants = {
    ADMIN_DATABASE: 'Database admin',
    ADMIN_NETWORK: 'Network admin',
    ADMIN_SERVER: 'Server admin',
    ADMIN_STORAGE: 'Storage admin',
    ON_PREM_IT_LABOR_TITLE: 'On-Premises IT labor cost',
};

const mainframeConstants = {
    ADD_ENVIRONMENT: 'Add environment',
    AMOUNT_COLUMN_HEADER: 'Amount',
    APP_ENVIRONMENTS: 'Application environments',
    APP_ENV_COUNT: 'Application environment count',
    AVG_MIPS_USAGE_BATCH: 'Average MIPS usage batch',
    AVG_MIPS_USAGE_DB: 'Average MIPS usage database',
    AVG_MIPS_USAGE_OLTP: 'Average MIPS usage OLTP',
    AVG_MIPS_USAGE_TOTAL: 'Average MIPS usage total',
    AVG_BATCH_MIPS: 'Average batch MIPS',
    AVG_DATABASE_MIPS: 'Average database MIPS',
    AVG_OLTP_MIPS: 'Average OLTP MIPS',
    AWS_ANNUAL_COST: 'AWS annual cost',
    AWS_COST: 'AWS cost',
    AWS_INFRASTRUCTURE: 'AWS infrastructure',
    BACKUP: 'Backup',
    BACKUP_TAPE: 'Backup tape (TB)',
    BACKUP_TAPE_RETRIEVAL: 'Backup tape retrieval (TB)',
    BACKUP_TAPE_STORAGE_RETRIEVAL: 'Backup tape storage retrieval (TB)',
    BACKUP_TAPE_STORAGE_USED: 'Backup tape storage used (TB)',
    BATCH_HOURS: 'Batch hours',
    BATCH_UPTIME_PER_WEEK: 'Batch uptime hours per week',
    BY_DEFAULT_PERCENT_OF_PROD_VALUE: '(by default, {0}% of Prod value)',
    COMPUTE: 'Compute',
    CONFIRM_DELETE: 'Confirm delete',
    CONFIRM_DELETE_MAINFRAME: 'Confirm delete mainframe',
    CONNECTIVITY: 'Connectivity',
    COST_IN: 'Cost in',
    COST_PER_YEAR_HEADER: 'Cost/Year',
    CREATE_A_SHORT_MAINFRAME_NAME: 'Create a short, descriptive name for your mainframe workload or the entire mainframe site',
    CREATE_WORKLOAD: 'Create workload',
    CUMULATIVE_AWS_MIGRATION: 'Cumulative cost - AWS Migration',
    CUMULATIVE_CASHFLOW_TITLE: 'Cumulative Costs',
    CUMULATIVE_DIFFERENCE: 'Cumulative cost difference',
    CUMULATIVE_NO_CHANGE: 'Cumulative cost - No Change',
    CUMULATIVE_SAVINGS: 'Cumulative savings %',
    DATA_TRANSFER_OUT: 'Data transfer out (GB)',
    DATA_USAGE: 'Data usage',
    DB_DISK_USED: 'Database disk used (TB)',
    DB_ENV_COUNT: 'Database environment count',
    DELETE_MAINFRAME_ENV_CONFIRM_MSG: 'Are you sure you want to delete this mainframe environment? This action cannot be undone.',
    DEV: 'Dev',
    DISASTER_RECOVERY: 'Disaster Recovery',
    DISASTER_RECOVERY_COLUMN_HEADER: 'Disaster Recovery?',
    DISK_STORAGE_USED: 'Disk storage used (TB)',
    DISK_STORAGE_USED_FILE: 'Disk storage used file (conf, logs) (TB)',
    ENVIRONMENT: 'Environment',
    ENVIRONMENTS: 'Environments',
    ENVIRONMENT_NAME: 'Environment name',
    ENVIRONMENT_TYPE: 'Environment type',
    ERROR_DOWNLOADING_MAINFRAME_ASSESSMENT: 'Failed to download mainframe assessment',
    ERROR_LOADING_MAINFRAME_ASSESSMENT: 'Failed to load mainframe assessment',

    FAILED_TO_DELETE_MAINFRAME: 'Failed to delete mainframe',
    FAILED_TO_LOAD_EXISTING_MAINFRAME: 'Failed to load existing mainframe',
    FAILED_TO_LOAD_MAINFRAMES: 'Failed to load mainframes',
    FAILED_TO_SAVE_MAINFRAME: 'Failed to save mainframe',
    FILE_DISK_USED: 'Files disk used (TB)',
    HSM_SMS_TAPE: 'HSM and SMS tape (TB)',
    HSM_SMS_TAPE_RETRIEVAL: 'HSM and SMS tape retrieval (TB)',
    HSM_SMS_TAPE_STORAGE_RETRIEVAL: 'HSM and SMS tape storage retrieval (TB)',
    HSM_SMS_TAPE_STORAGE_USED: 'HSM and SMS tape storage used (TB)',
    MAINFRAMES: 'Mainframes',
    MAINFRAME_ALERT_1: 'You can enter the workload specific data in',
    MAINFRAME_ALERT_2: ', and see the Mainframe assessment (rough order of magnitude) on the ',
    MAINFRAME_ALERT_3: ' page.',
    MAINFRAME_ALERT_4: ' At the moment, Mainframe results are not part of the main ',
    MAINFRAME_ALERT_5: 'or any of the other TCO pages, nor are they considered in \'Migration strategy\', \'Migration cost\' or \'Planning\'.',
    MAINFRAME_IS_SEPARATE_FROM_MAIN_TCO: 'Mainframe workload assessment is separate from the main TCO in MPA',
    MAINFRAME_PREVIEW: 'Mainframe workload assessment in MPA is a preview feature',
    MAINFRAME_SUMMARY: 'Mainframe summary',
    MAINFRAME_TAB_LABEL_AWS_DETAILS: 'AWS details',
    MAINFRAME_TAB_LABEL_CASH_FLOW: 'Cash flow',
    MAINFRAME_TAB_LABEL_SUMMARY: 'Summary',
    MAINFRAME_WORKLOAD: ' mainframe workload',
    MAINFRAME_WORKLOADS: 'Mainframe workloads',
    MAINFRAME_WORKLOAD_ANNUAL_COST: 'Mainframe workloads annual cost',
    MAINFRAME_WORKLOAD_CONFIG: 'Mainframe workload configuration',
    MAINFRAME_WORKLOAD_NAME: 'Mainframe workload name*',
    MIGRATION_CASH_FLOW_TABLE_HEADER: 'Migration cash flow',
    MIGRATION_COST: 'Migration cost',
    MONTHLY_COST: 'Monthly cost',
    NUMBER_OF_INTEGRATED_DEPENDENCIES: 'Number of integrated dependencies',
    NUMBER_OF_LOC: 'Number of lines of code (LOC)',
    NUMBER_OF_TEST_CASES: 'Number of test cases',
    OCCUPANCY: 'Occupancy',
    OLTP_HOURS: 'OLTP hours',
    OLTP_UPTIME_PER_WEEK: 'OLTP uptime hours per week',
    ON_PREM_COST: 'Mainframe workloads cost',
    OTHER_COSTS: 'Other costs',
    PERSONNEL: 'Personnel',
    PLEASE_NOTE: 'Please note!',
    PROD: 'Prod',
    PROJECT_DURATION: 'Project duration (years)',
    RESOURCE_NAME: 'Resource Name',
    SEPARATE_APP_ENVS: 'Separate application environments',
    SEPARATE_DB_ENVS: 'Separate database environments',
    SI_PROSERVE_LABOR_COST: 'SI or ProServe labor costs',
    SOFTWARE_IBM_3RD_PARTY: 'Software (IBM + 3rd party)',
    STORAGE: 'Storage',
    TEST: 'Test',
    THIRD_PARTY_SOFTWARE: '3rd party software',
    TOOL_LICENSE_SOFTWARE_COST: 'Tool license & services costs',
    TOTAL_AWS_MIGRATION: 'Total annual cost - AWS Migration',
    TOTAL_CASHFLOW_TITLE: 'Annual Costs',
    TOTAL_DIFFERENCE: 'Total annual cost difference',
    TOTAL_INSTALLED_MIPS: 'Total installed MIPS (For cost/MIPS)',
    TOTAL_NO_CHANGE: 'Total annual cost - No Change',
    TOTAL_SAVINGS: 'Savings %',
    UNALLOCATED: 'Unallocated',
    UNIT_MONTHLY_COST: 'Unit monthly cost',
    UNSAVED_CHANGES_WILL_BE_LOST: 'Unsaved changes will be lost',
    UNSAVED_CHANGES_WILL_BE_LOST_CONTINUE: 'Any unsaved changes will be lost. Are you sure you want to proceed?',
    WORKLOAD_NAME: 'Workload Name',
    YOU_HAVE_NOT_YET_ENVS: 'You have not yet added any environments to this workload.',
    YOU_HAVE_NOT_YET_MAINFRAMES: 'You have not yet created any mainframes in this portfolio',
};

const unitConstants = {
    MBITS_PER_SECOND: 'Mbits per second',
};

const appCentricConstants = {
    ADD_OWNER: 'Add owner',
    ALL_APPLICATIONS: 'All applications',
    ALL_ENVIRONMENTS: 'All environments',
    APPLICATION_COST_DETAIL_HAS_NOT_BEEN_COMPUTED: 'The application cost has not been computed',
    APPLICATION_COST_SUMMARY: 'Application cost summary',
    ATTRIBUTES: 'Attributes',
    AWS_COMPUTE_COST: 'AWS compute cost',
    AWS_DB_LICENSE: 'Database license - 3rd party',
    AWS_RECOMMENDATION: 'AWS recommendation',
    AWS_RECOMMENDATION_NOT_COMPUTED: 'AWS recommendation has not been computed',
    BRING_YOUR_OWN_LICENSE: 'Bring your own license',
    CANNOT_LOAD_APP_DETAIL: 'Encountered an error loading application',
    CANNOT_UPDATE_IN_SCOPE: 'Encountered an error updating inScope',
    COMMON: 'Common',
    COMPUTE_COST: 'Compute cost',
    COST_DETAILS: 'Cost details',
    COST_PROPORTION: 'Cost proportion',
    DATABASE_COST_CAPITALIZED: 'Database cost',
    DATABASE_LICENSE: 'Database license - 3rd party',
    DB_ENGINE: 'Database engine',
    DEPARTMENT: 'Department',
    DEPLOYMENT_OPTION: 'Deployment option',
    DESCRIPTION: 'Description',
    DIRECT_CAPITALIZED: 'Direct',
    EBS: 'EBS',
    EC2: 'EC2',
    EC2_RECOMM_NOT_MADE_FOR_SERVER: 'An EC2 recommendation was not made for this server.',
    ENCOUNTERED_ERROR_FILTERING_BASED_ON_ENVIRONMENT: 'Encountered an error filtering based on environment: ',
    ENCOUNTERED_ERROR_LOADING_APP: 'Encountered an error loading application: ',
    ENCOUNTERED_ERROR_LOADING_APP_DB_DETAILS: 'Encountered an error loading application database details: ',
    ENCOUNTERED_ERROR_LOADING_APP_SERVER_DETAILS: 'Encountered an error loading application server details',
    ENCOUNTERED_ERROR_UPDATING_DB_INSCOPE: 'Encountered an error updating database inScope: ',
    ENCOUNTERED_ERROR_UPDATING_SERVER_INSCOPE: 'Encountered an error updating server inScope: ',
    FAILED_TO_LOAD_APP_COST_DETAIL: 'Encountered an error loading the \'Application cost details\'',
    FAILED_TO_LOAD_APP_COST_SUMMARY: 'Encountered an error loading the \'Application cost summary\'',
    FAILED_TO_LOAD_SCHEMAS: 'Failed to load schemas',
    FIFTEEN_DBS: '15 databases',
    FIFTEEN_SERVERS: '15 servers',
    FIVE_DBS: '5 databases',
    FIVE_SERVERS: '5 servers',
    GIB: 'GiB',
    HARDWARE: 'Hardware',
    HYPERVISOR: 'Hypervisor',
    IN_AWS: 'In AWS',
    IN_SCOPE_OF_PORTFOLIO: 'In Scope of Portfolio',
    INSTANCE: 'Instance',
    LABOR: 'Labor',
    LABOR_COST: 'Labor cost',
    LICENSE_COST: 'License cost',
    LICENSE_MODEL: 'License model',
    LINK: 'Link',
    LOADING_DATABASES: 'Loading databases',
    LOADING_SERVERS: 'Loading servers',
    ADJUSTMENT: 'Adjustment',
    MAX_IOPS: 'max IOPS',
    MAX_THROUGHPUT: ' max throughput',
    MISSING_DATABASES: 'Missing database(s): ',
    MISSING_SERVERS: 'Missing server(s): ',
    MPA_ONLY_HANDLES_DB_FOR_RDS_OR_EC2_RECOMMENDATION: 'MPA handles databases for EC2 with SQL server or RDS recommendations.' +
        ' Enable EC2 and/or RDS recommendations in \'Assumptions > AWS database recommendation\'.',
    NO_OWNER_ASSIGNED_TO_APP: 'Currently there isn\'t an owner assigned to this application for data collection.',
    NETWORK_COST: 'Network cost',
    NO_RESOURCES: 'No resources',
    NO_RESOURCES_TO_DISPLAY: 'No resources to display.',
    NON_PRODUCTION: 'Non-Production',
    ON_PREM: 'On-Prem',
    ON_PREM_VS_AWS: 'On-Premises vs AWS specifications',
    OS: 'OS',
    OS_LICENSE: 'OS License - 3rd party',
    OTHER_COST_CAPITALIZED: 'Other cost',
    OVERVIEW: 'Overview',
    OWNER: 'Owner',
    PAGE_SIZE: 'Page size',
    PHYSICAL: 'Physical',
    PRODUCTION: 'Production',
    QUESTIONNAIRE: 'Questionnaire',
    RECALCULATE_TCO_MESSAGE: 'Visit the TCO summary page and click the \'Calculate\' button at the top of the page.',
    RECALCULATE_TCO_MESSAGE_HEADER: 'Please (re)calculate TCO to use this feature',
    RDS: 'RDS',
    RECOMMENDATION_NOT_MADE_FOR_DB: 'No recommendation was made for this database.',
    RECOMMENDED_PAYMENT_OPTION: 'Recommended payment option',
    RETURN_TO_TCO_AND_CALCULATE: 'Please return to portfolio level TCO and run \'Calculate\'.',
    RI_DISCOUNT: 'RI Volume Discount',
    SERVER_COST_CAPITALIZED: 'Server cost',
    SERVER_WITH_ID_DOES_NOT_EXIST: 'A server with the \'Server ID\' {0} does not exist.',
    SERVER_WITH_ID_IS_OUT_OF_SCOPE: 'The server with the \'Server ID\' {0} is out of scope.',
    SHOW_ONLY_ATTRIBUTES_WITH_VALUES: 'Show only attributes with values',
    SOFTWARE_COST: 'Software cost',
    SPECS: 'Specs',
    STORAGE_BACKUP: 'Storage backup',
    STORAGE_COST: 'Storage cost',
    STORAGE_RACK: 'Storage rack',
    STORAGE_SOFTWARE: 'Storage software',
    SUPPORT_COST: 'Support cost',
    TEN_DBS: '10 databases',
    TEN_SERVERS: '10 servers',
    TITLE: 'Title',
    TITLE_DESCRIPTION: 'A title for this chart',
    TOTAL_COMMON_COST: 'Total common cost',
    TOTAL_COSTS_CAPITALIZED: 'Total costs',
    TOTAL_DIRECT_COST: 'Total direct cost',
    UPDATE_SUMMARY_TOTALS: 'Update summary totals',
    UPTIME: 'Uptime',
    UTILIZATION_METHOD: 'Utilization method: ',
    YEAR_SUBSCRIPTION: ' Year subscription',
    VIRTUALIZATION: 'Virtualization',
    VOLUME: 'Volume',
    YOU_CAN_SET_SERVER_IN_SCOPE: 'You can either set the server to in-scope, or update the database \'Server ID\' attribute to an in-scope server.',
    YOU_CAN_ADD_SERVER_OR_UPDATE_DB_SERVER_ID: 'You can either add the server, or update the database \'Server ID\' attribute to an existing server.',
};

const tutorialPanelConstants = {
    // Tour Panel
    TOUR_COMPLETED: 'Congratulations! You completed the tutorial',
    TOUR_COMPLETED_TEXT: 'Tutorial completed',
    TOUR_DISMISS: 'Dismiss Tutorial',
    TOUR_DOWNLOAD_LINK_TEXT: '',
    TOUR_EXIT_LABEL: 'Dismiss tutorial',
    TOUR_FEEDBACK: 'Feedback',
    TOUR_IN_PROGRESS: 'in-progress',
    TOUR_LEARN_MORE: 'Learn more',
    TOUR_LEARN_MORE_ICON: 'Learn more here',
    TOUR_LIST_DESCRIPTION: 'Learn to use MPA by completing the following tutorials.',
    TOUR_LIST_TITLE: 'Choose a tutorial',
    TOUR_LOADING: 'loading',
    TOUR_PENDING: 'pending',
    TOUR_RESTART: 'Restart tutorial',
    TOUR_START: 'Start tutorial',
    TOUR_STEP: 'Step',
    TOUR_SUCCESS: 'success',
    TOUR_TASK: 'Task',
    TOUR_TOTAL_STEPS: 'Total steps:',

    //Tour Overlay
    TOUR_FINISH: 'Finish',
    TOUR_HIDE_ANNODATION: 'hide annotation',
    TOUR_NEXT: 'Next',
    TOUR_SHOW_ANNOTATION: 'show annotation',
    TOUR_PREVIOUS: 'Previous',
};

const sidePanelConstants = {
    INFO_TAB: 'Info',
    TUTORIAL_TAB: 'Tutorials'
};

const tourDefinitionConstants = {
    //All Tours
    COMPLETED_SCREEN_DESCRIPTION: 'Thanks for completing this tutorial.',

    //Import Wizard Tour
    IMPORT_FROM_FILE_DESCRIPTION: 'In this tutorial you will learn how to use the import from file flow in MPA.',
    DOWNLOAD_SAMPLE_FILE: 'Download sample file',
    DOWNLOAD_SAMPLE_FILE_CONTENT: 'Click the "Sample files" link to download the sample file that we will use to import the servers data in this tutorial.',
    IMPORT_SERVERS_DATA: 'Import servers data',
    UPLOAD_SERVERS_DATA: 'Upload servers data',
    UPLOAD_SERVERS_DATA_CONTENT: 'Click "Upload local file" and select the sample file you download in the previous task.',
    SELECT_SHEET: 'Select sheet',
    SELECT_SHEET_CONTENT: 'Specify the worksheet that has the servers data. Click "Next" to proceed.',
    RECOMMENDED_HEADER_MAPPING: 'Recommended header mapping',
    RECOMMENDED_HEADER_MAPPING_CONTENT: 'MPA attempts to auto-map the correct attribute in the input file to each expected header. Recommended headers ' + 
    'are the most important attributes that MPA uses. Here it has found for example the corresponding attribute for "Server ID"; should that not ' + 
    'have been the case, you would need to specify it from the dropdown. Similarly, MPA attempts to auto-map the correct unit of ' + 
    'measure (UOM) based on the values in the input file. Here it has determined "Ratio" as the UOM; should that not have been the ' + 
    'case, you would need to specify it before proceeding to the next step.',
    CONFIRM_IMPORT: 'Confirm import',
    REVIEW_AND_CONFIRM: 'Review and confirm import',
    REVIEW_AND_CONFIRM_CONTENT: 'You can review all the data MPA has identified in the provided file per the provided header mappings. Click ' + 
    '"Confirm Import" to proceed; MPA will import this data and you will be redirected to the Assets > Servers page.'
};

const adjustmentsConstants = {
    ADD_CORRESPONDING: 'Add corresponding',
    ADJUSTMENTS: 'Adjustments',
    ALSO_DELETE_CORRESPONDING: 'Also delete corresponding adjustments?',
    AMOUNT: 'Amount',
    AMOUNT_DESCRIPTION: 'Adjustment amount (can be negative)',
    APPLICATION_SOFTWARE: 'Application software',
    AWS_SERVICE: 'AWS Service',
    AWS_SUPPORT_DESCRIPTION: 'Enable if this amount should be considered in the AWS usage used for calculating the AWS Support cost',
    CONSIDERED_FOR_AWS_SUPPORT: 'Considered for AWS Support?',
    COST_CATEGORY: 'Cost category',
    DELETE_ADJUSTMENT: 'Delete adjustment?',
    DELETE_ADJUSTMENT_TEXT: 'Once you click \'Save\' this adjustment will be deleted. This action cannot be undone. Do you want to proceed?',
    DELETE_SELECTED_ADJUSTMENTS: 'Delete selected adjustments?',
    DETAILED_DESCRIPTION: 'Detailed description',
    ERROR_CREATE_ADJUSTMENT: 'Unable to create adjustment',
    ERROR_DELETING_ADJUSTMENTS: 'Error deleting adjustments',
    ERROR_LOADING_ADJUSTMENT: 'Error loading selected adjustment',
    ERROR_LOADING_ADJUSTMENTS: 'Error loading adjustments',
    ERROR_NO_ADJUSTMENT_FOUND: 'No adjustment found with the given id',
    FREQUENCY: 'Frequency',
    FREQUENCY_DESCRIPTION: 'The frequency with which the amount is to be applied',
    IN_SCOPE: 'In Scope',
    IN_SCOPE_ADJUSTMENT_DESCRIPTION: 'Is this cost considered in scope for TCO calculations?',
    MANAGED_SERVICES: 'Managed services',
    OTHER: 'Other',
    SELECTED_ADJUSTMENTS_IN_BOLD: 'Selected adjustments are displayed in bold',
    SERVICE_DESCRIPTION: 'Select an AWS service or type in your own short description',
    SHORT_DESCRIPTION: 'Short description',
    SUCCESS_CREATE_ADJUSTMENT: 'Successfully created adjustment!',
    SUCCESS_UPDATING_ADJUSTMENT: 'Successfully updated adjustment!',
    SUPPORT: 'Support',
    YEARLY_COST: 'Yearly cost',
};

const splitPanelConstants = {
    PREFERENCES_TITLE: 'Split panel preferences',
    PREFERENCES_POSITION_LABEL: 'Split panel position',
    PREFERENCES_POSITION_DESCRIPTION: 'Choose the default split panel position for the service.',
    PREFERENCES_POSITION_SIDE: 'Side',
    PREFERENCES_POSITION_BOTTOM: 'Bottom',
    CLOSE_BUTTON_ARIA_LABEL: 'Close panel',
    OPEN_BUTTON_ARIA_LABEL: 'Open panel',
    RESIZE_HANDLE_ARIA_LABEL: 'Resize split panel',
};

const preInstalledSwConstants = {
    NA: '-',
    SQL_SERVER_ENT: 'SQL Server Enterprise',
    SQL_SERVER_STD: 'SQL Server Standard',
    SQL_SERVER_WEB: 'SQL Server Web'
};

export const constants = {
    AWS_PORTFOLIO_ASSESSMENT_TITLE: 'Migration Portfolio Assessment',
    AWS_PORTFOLIO_ASSESSMENT_DESC: 'Automate portfolio analysis and business case validation.',
    ...adjustmentsConstants,
    ...appCentricConstants,
    ...appDependenciesTableConstants,
    ...appToServerTableConstants,
    ...applicationGroupCompositionConstants,
    ...applicationGroupConstants,
    ...applicationGroupDependencyConstants,
    ...applicationGroupDependencyGraphConstants,
    ...applicationGroupDetailConstants,
    ...applicationPrioritizationConstants,
    ...applicationsTableConstants,
    ...attributeActionsConstants,
    ...breadcrumbConstants,
    ...commonConstants,
    ...createNewPortfolioConstants,
    ...editPortfolioConstants,
    ...profileTagEditorConstants,
    ...contactManagementConstants,
    ...dataCollectionConstants,
    ...dashboardConstants,
    ...databaseTableConstants,
    ...dataQualityConstants,
    ...dbToAppTableConstants,
    ...dependencyValidation,
    ...ec2CostConstants,
    ...ec2RecommendationConstants,
    ...ec2RecommendationDedicatedHostConstants,
    ...ec2RecommendationVMWareConstants,
    ...feedbackConstants,
    ...formConstants,
    ...helpPanelConstants,
    ...importADSConstants,
    ...importConstants,
    ...itLaborSupportCostConstants,
    ...leftNavConstants,
    ...mainframeConstants,
    ...migrationStrategyCashflowConstants,
    ...migrationStrategyConstants,
    ...migrationStrategyCountConstants,
    ...migrationStrategySummaryConstants,
    ...migrationWaveConstants,
    ...networkConstants,
    ...olaAssessmentConstants,
    ...paymentOptionsCommonConstants,
    ...portfoliosTableConstants,
    ...preInstalledSwConstants,
    ...previewBannerConstants,
    ...rdsCostConstants,
    ...rdsRecommendationConstants,
    ...recentPortfolioConstants,
    ...serverCommTableConstants,
    ...serverTableConstants,
    ...sharePortfolioConstants,
    ...sharedStorageConstants,
    ...shortbreadConstants,
    ...sidePanelConstants,
    ...splitPanelConstants,
    ...tcoActionPanelConstants,
    ...tcoAssessmentModalConstants,
    ...tcoAssumptionsConstants,
    ...tcoCommonConstants,
    ...tcoExcludedServersAlertConstants,
    ...tcoFooterConstants,
    ...tcoAwsStorageAndNetworkConstants,
    ...tcoOnPremiseITLaborConstants,
    ...tcoOnPremisesStorageAndNetworkConstants,
    ...tcoOnPremServerCostPageConstants,
    ...tcoSavingsSummaryPageConstants,
    ...tcoSummaryPageConstants,
    ...tutorialPanelConstants,
    ...tourDefinitionConstants,
    ...unitConstants,
};

export enum DatabaseWarningMessages {
    IOPS_PRICE_MATCH_NOT_FOUND = 'with price match not found for the given attributes in the Provisioned IOPS product family;'
        + ' check \'Storage-Max Read/Write IOPS\' and \'Storage-Total Disk Size\' of the corresponding server.',
    STORAGE_PRICE_MATCH_NOT_FOUND = 'mapped to missing or out of scope server; check the \'Server ID\' on the database,'
        + ' and the \'In Scope of Portfolio\' for the corresponding server; MPA is case sensitive!',
    OVER_STORAGE_MAX = 'with Storage Size higher than the Max supported size; check the \'DB Size\' on the database.',
    MAPPED_TO_MISSING_SERVER = 'with price match not found for the given attributes in the Database Storage product family;'
        + ' check \'Target AWS DB Service\', \'DB Instance Deployment Option\', \'Enterprise / Standard Edition\' and \'License Model\' on the database'
        + ' - some combinations might not be valid.',
};

export enum StorageWarningMessages {
    INVALID_DISK_SIZE = 'with 0 storage size; check \'Storage-Total Disk Size\'.',
    INVALID_SERVER_UPTIME_RATIO = 'with server uptime ratio outside of the 0 and 1 range; check \'Server-Usage\'.',
    IOPS_EXCEED_INSTANCE_MAX = 'with IOPS exceeding the max supported by the recommended instance type; check \'Storage-Max Read/Write IOPS\'.',
    IOPS_EXCEED_SIZE_MAX_RATIO = 'with IOPS exceeding the max IOPS to GB ratio permitted by any of the selected volumes;'
        + 'check \'Storage-Max Read/Write IOPS\' and \'Storage-Total Disk Size\'.',
    NO_MATCHING_OFFERS = 'with no matching offers.',
    OUT_OF_SCOPE = 'marked \'Out of Scope\'. You can update the \'In Scope of Portfolio\' ' 
        +'server attribute on the Server data page to include or exclude servers from analysis.',
    SERVER_HAS_NO_EC2_RECOMMENDATION = 'with no corresponding EC2 recommendations; check for warnings in \'TCO > AWS > EC2 recommendations\'.',
    SHARED_STORAGE_EXCLUSION = 'with the Max IOPS and/or Max Throughput higher than the corresponding values of recommended EC2 instance type,'
        + ' or of all the EBS volume types selected.'
        + ' Check their values for the \'Storage-Max Read IOPS\', \'Storage-Max Write IOPS\', \'Storage-Max Read IOPS Size\' and'
        + ' \'Storage-Max Write IOPS Size\' in \'Assets > Servers\'.',
    SPECS_EXCEED_VOLUMES_MAX = 'with IOPS and/or throughput exceeding the max supported by the EBS volume types; '
        + 'check \'Storage-Max Read/Write IOPS\' and \'Storage-Max Read/Write IOPS Size\'.',
    THROUGHPUT_EXCEEDS_INSTANCE_MAX = 'with throughput exceeding the max supported by the recommended instance type;'
        + ' check \'Storage-Max Read/Write IOPS Size\'.',
    VOLUME_APIS_NON_ELIGIBLE = 'with no eligible volume types. Please note that if you have selected only HDD options, '
        + 'those are not supported for storage of physical servers. You can enable \'Consider storage of physical servers as SAN\' in'
        + ' \'Assumptions > General storage\' to have storage of physical servers handled same as for virtual servers.',
};

export enum ServerWarningMessages {
    DATABASE_SERVER = 'linked to in scope databases, therefore not considered for EC2 recommendations.',
    FAILED_DEDICATED_HOST = 'with Dedicated Host tenancy, but that can\'t be assessed for Dedicated Host. '
        + 'This can be due to too high values for the on-prem specifications (\'CPU-Number of Processors\', \'CPU-Cores per Processor\', '
        + '\'CPU-Number of Threads per CPU-Core\', \'RAM-Total Size\'), or due to incompatibilities between the specifications. '
        + 'You can review the attributes, update as needed or update the Tenancy to Shared or Dedicated for them to be considered for '
        + 'regular EC2 recommendations the next time you run the analysis.',
    MAPPED_TO_SHARED_DEDICATED_HOST = 'were assessed for Dedicated Host tenancy, but due to host underutilization, '
        + 'they might be better handled as Shared / Dedicate Instance tenancy. '
        + 'Change the tenancy and then click Calculate again for an updated cost, '
        + 'or click Apply to have the change applied automatically.',
    OUT_OF_SCOPE = 'marked \'Out of Scope\'. You can update the \'In Scope of Portfolio\' ' 
        +'server attribute on the Server data page to include or exclude servers from analysis.',
    RETAINED_SERVER = 'have Retain Migration strategy. You can update the \'Migration strategy\' attribute '
    + 'on the Migration strategy page to mark or unmark servers as Retain.',
    RETIRED_SERVER = 'have Retire Migration strategy. You can update the \'Migration strategy\' attribute '
        + 'on the Migration strategy page to mark or unmark servers as Retire.',
    UNMATCHED_SERVER = 'without EC2 recommendations. This can be due to too high values for the on-prem specifications'
        + ' (\'CPU-Number of Processors\', \'CPU-Cores per Processor\', \'CPU-Number of Threads per CPU-Core\', \'RAM-Total Size\'), '
        + 'or due to incompatibilities between the specifications, the OS and the server level preferences (EC2 Instance Preferences). '
        + 'You can review the attributes, update as needed and rerun the analysis. You can still manually override the instance type in the below.',
    
};

export enum DatabaseWarningMessages {
    EC2_ORACLE_DATABASE = 'assessed for EC2 with Oracle bring your own license',
    UNMATCHED_DATABASE = 'without RDS recommendations. They are excluded from the AWS Database Recommendations. Please review their attributes'
        + ' (\'Target AWS DB Service\', \'DB Instance Engine/Software\', \'CPU-Number of Processors\', \'CPU-Cores per Processor\', \'RAM-Total Size\' ...),'
        + ' update and rerun the analysis.',
    UNLINKED_DATABASE = 'without RDS recommendations. These database(s) are mapped to servers'
    + ' that either don’t exist in the portfolio or are out of scope. Please validate the server ids on' 
    + ' the database(s) and make the necessary corrections.',
    EC2_SQL_SERVER_DATABASE = 'assessed for EC2 with included SQL Server.',
    ORACLE_STANDARD_LICENSE_OVER_LIMIT = 'for which the database license was not estimated; ' +
        'the number of vCPUs is greater than 16, the allowed Oracle limit for this edition.',
    ORACLE_STANDARD_ONE_TWO_LICENSE_OVER_LIMIT = 'for which the database license was not estimated; ' +
        'the number of vCPUs is greater than 8, the allowed Oracle limit for this edition.',
};
